{
  "analysis.modes.query.label": "crwdns2661:0crwdne2661:0",
  "analysis.modes.query.description": "crwdns2663:0crwdne2663:0",
  "analysis.modes.funnel.label": "crwdns2665:0crwdne2665:0",
  "analysis.modes.funnel.description": "crwdns2667:0crwdne2667:0",
  "analysis.modes.flow.label": "crwdns2669:0crwdne2669:0",
  "analysis.modes.flow.description": "crwdns2671:0crwdne2671:0",
  "analysis.modes.retention.label": "crwdns2673:0crwdne2673:0",
  "analysis.modes.retention.description": "crwdns2675:0crwdne2675:0",
  "analysis.ai.title": "crwdns2677:0crwdne2677:0",
  "analysis.ai.generating": "crwdns2679:0crwdne2679:0",
  "analysis.ai.placeholder": "crwdns2681:0crwdne2681:0",
  "analysis.ai.shortcutHint": "crwdns2683:0crwdne2683:0",
  "analysis.ai.successMessage": "crwdns2685:0crwdne2685:0",
  "analysis.ai.button.accept": "crwdns2687:0crwdne2687:0",
  "analysis.ai.button.cancel": "crwdns2689:0crwdne2689:0",
  "analysis.ai.button.close": "crwdns2691:0crwdne2691:0",
  "analysis.ai.button.generate": "crwdns2693:0crwdne2693:0",
  "analysis.ai.button.generating": "crwdns2695:0crwdne2695:0",
  "analysis.sections.metrics": "crwdns2697:0crwdne2697:0",
  "analysis.sections.breakdown": "crwdns2699:0crwdne2699:0",
  "analysis.sections.dimensions": "crwdns2701:0crwdne2701:0",
  "analysis.sections.filters": "crwdns2703:0crwdne2703:0",
  "analysis.sections.limit": "crwdns2705:0crwdne2705:0",
  "analysis.tabs.query": "crwdns2707:0crwdne2707:0",
  "analysis.tabs.chart": "crwdns2709:0crwdne2709:0",
  "analysis.tabs.chartTitle": "crwdns2711:0crwdne2711:0",
  "analysis.tabs.display": "crwdns2715:0crwdne2715:0",
  "analysis.tabs.displayTitle": "crwdns2717:0crwdne2717:0",
  "analysis.multiQuery.removeQuery": "crwdns2721:0crwdne2721:0",
  "analysis.multiQuery.addQuery": "crwdns2723:0crwdne2723:0",
  "analysis.multiQuery.addAnother": "crwdns2725:0crwdne2725:0",
  "analysis.multiQuery.mergeExplanation": "crwdns2727:0crwdne2727:0",
  "analysis.multiQuery.switchToSeparate": "crwdns2729:0crwdne2729:0",
  "analysis.mergeStrategy.concat": "crwdns2731:0crwdne2731:0",
  "analysis.mergeStrategy.merge": "crwdns2733:0crwdne2733:0",
  "analysis.mergeStrategy.funnel": "crwdns2735:0crwdne2735:0",
  "analysis.placeholders.addMetrics": "crwdns2737:0crwdne2737:0",
  "analysis.placeholders.hoverField": "crwdns2739:0crwdne2739:0",
  "analysis.placeholders.noData": "crwdns2741:0crwdne2741:0",
  "common.actions.accept": "crwdns2743:0crwdne2743:0",
  "common.actions.cancel": "crwdns2745:0crwdne2745:0",
  "common.actions.delete": "crwdns2747:0crwdne2747:0",
  "common.actions.close": "crwdns2749:0crwdne2749:0",
  "common.actions.edit": "crwdns2751:0crwdne2751:0",
  "common.actions.save": "crwdns2753:0crwdne2753:0",
  "common.actions.copy": "crwdns2755:0crwdne2755:0",
  "common.actions.duplicate": "crwdns2757:0crwdne2757:0",
  "common.actions.refresh": "crwdns2759:0crwdne2759:0",
  "common.actions.confirm": "crwdns2761:0crwdne2761:0",
  "common.actions.add": "crwdns2763:0crwdne2763:0",
  "common.actions.clear": "crwdns2765:0crwdne2765:0",
  "common.actions.select": "crwdns2767:0crwdne2767:0",
  "common.actions.navigate": "crwdns2769:0crwdne2769:0",
  "common.actions.share": "crwdns2771:0crwdne2771:0",
  "common.loading": "crwdns2773:0crwdne2773:0",
  "common.modal.processing": "crwdns2775:0crwdne2775:0",
  "common.modal.dashboardName": "crwdns2777:0crwdne2777:0",
  "common.modal.deleteConfirmation": "crwdns2779:0crwdne2779:0",
  "common.sorting.ascending": "crwdns2781:0crwdne2781:0",
  "common.sorting.descending": "crwdns2783:0crwdne2783:0",
  "common.sorting.none": "crwdns2785:0crwdne2785:0",
  "fieldTypes.count": "crwdns2787:0crwdne2787:0",
  "fieldTypes.countDistinct": "crwdns2789:0crwdne2789:0",
  "fieldTypes.countDistinctApprox": "crwdns2791:0crwdne2791:0",
  "fieldTypes.sum": "crwdns2793:0crwdne2793:0",
  "fieldTypes.avg": "crwdns2795:0crwdne2795:0",
  "fieldTypes.min": "crwdns2797:0crwdne2797:0",
  "fieldTypes.max": "crwdns2799:0crwdne2799:0",
  "fieldTypes.runningTotal": "crwdns2801:0crwdne2801:0",
  "fieldTypes.number": "crwdns2803:0crwdne2803:0",
  "fieldTypes.string": "crwdns2805:0crwdne2805:0",
  "fieldTypes.boolean": "crwdns2807:0crwdne2807:0",
  "fieldTypes.time": "crwdns2809:0crwdne2809:0",
  "fieldTypes.geo": "crwdns2811:0crwdne2811:0",
  "fieldTypes.dimension": "crwdns2813:0crwdne2813:0",
  "fieldPanel.emptyState": "crwdns2815:0crwdne2815:0",
  "fieldPanel.usageHint": "crwdns2817:0crwdne2817:0",
  "fieldPanel.labels.type": "crwdns2819:0crwdne2819:0",
  "fieldPanel.labels.cube": "crwdns2821:0crwdne2821:0",
  "fieldPanel.labels.category": "crwdns2823:0crwdne2823:0",
  "fieldCategory.measure": "crwdns2825:0crwdne2825:0",
  "fieldCategory.timeDimension": "crwdns2827:0crwdne2827:0",
  "fieldCategory.dimension": "crwdns2829:0crwdne2829:0",
  "fieldSearch.placeholder.metrics": "crwdns2831:0crwdne2831:0",
  "fieldSearch.placeholder.filter": "crwdns2833:0crwdne2833:0",
  "fieldSearch.placeholder.dimensions": "crwdns2835:0crwdne2835:0",
  "fieldSearch.modal.title.metrics": "crwdns2837:0crwdne2837:0",
  "fieldSearch.modal.title.filter": "crwdns2839:0crwdne2839:0",
  "fieldSearch.modal.title.dimensions": "crwdns2841:0crwdne2841:0",
  "fieldSearch.filter.allCubes": "crwdns2843:0crwdne2843:0",
  "fieldSearch.categories.all": "crwdns2845:0crwdne2845:0",
  "fieldSearch.empty.heading": "crwdns2847:0crwdne2847:0",
  "fieldSearch.empty.noMatchMetrics": "crwdns2849:0{searchTerm}crwdne2849:0",
  "fieldSearch.empty.noMatchDimensions": "crwdns2851:0{searchTerm}crwdne2851:0",
  "fieldSearch.empty.noMetrics": "crwdns2853:0crwdne2853:0",
  "fieldSearch.empty.noDimensions": "crwdns2855:0crwdne2855:0",
  "fieldSearch.section.recents": "crwdns2857:0crwdne2857:0",
  "fieldSearch.footer.metricsAvailable": "crwdns2859:0crwdne2859:0",
  "fieldSearch.footer.fieldsAvailable": "crwdns2861:0crwdne2861:0",
  "fieldSearch.footer.dimensionsAvailable": "crwdns2863:0crwdne2863:0",
  "fieldSearch.shortcut.navigate": "crwdns2865:0crwdne2865:0",
  "fieldSearch.shortcut.keyEnter": "crwdns3991:0crwdne3991:0",
  "fieldSearch.shortcut.keyShift": "crwdns3993:0crwdne3993:0",
  "fieldSearch.shortcut.keyEsc": "crwdns3995:0crwdne3995:0",
  "fieldSearch.shortcut.plusClick": "crwdns3997:0crwdne3997:0",
  "fieldSearch.shortcut.select": "crwdns2867:0crwdne2867:0",
  "fieldSearch.shortcut.multiSelect": "crwdns2869:0crwdne2869:0",
  "fieldSearch.shortcut.close": "crwdns2871:0crwdne2871:0",
  "filter.group.condition": "crwdns2873:0crwdne2873:0",
  "filter.group.conditions": "crwdns2875:0crwdne2875:0",
  "filter.group.addFilter": "crwdns2877:0crwdne2877:0",
  "filter.group.addAndGroup": "crwdns2879:0crwdne2879:0",
  "filter.group.addOrGroup": "crwdns2881:0crwdne2881:0",
  "filter.group.removeGroup": "crwdns2883:0crwdne2883:0",
  "filter.group.empty": "crwdns2885:0crwdne2885:0",
  "filter.group.addFilterLink": "crwdns2887:0crwdne2887:0",
  "filter.modal.title": "crwdns2889:0crwdne2889:0",
  "filter.modal.fieldLabel": "crwdns2891:0crwdne2891:0",
  "filter.modal.operatorLabel": "crwdns2893:0crwdne2893:0",
  "filter.modal.valueLabel": "crwdns2895:0crwdne2895:0",
  "filter.modal.selectRange": "crwdns2897:0crwdne2897:0",
  "filter.modal.noValueRequired": "crwdns2899:0crwdne2899:0",
  "filter.modal.dateTo": "crwdns2901:0crwdne2901:0",
  "filter.modal.min": "crwdns2903:0crwdne2903:0",
  "filter.modal.to": "crwdns2905:0crwdne2905:0",
  "filter.modal.max": "crwdns2907:0crwdne2907:0",
  "filter.modal.enterNumber": "crwdns2909:0crwdne2909:0",
  "filter.modal.loading": "crwdns2911:0crwdne2911:0",
  "filter.modal.selectValue": "crwdns2913:0crwdne2913:0",
  "filter.modal.search": "crwdns2915:0crwdne2915:0",
  "filter.modal.errorPrefix": "crwdns2917:0crwdne2917:0",
  "filter.modal.noValues": "crwdns2919:0crwdne2919:0",
  "filter.modal.multiSelectHint": "crwdns2921:0crwdne2921:0",
  "filter.modal.enterValue": "crwdns2923:0crwdne2923:0",
  "filter.removeButton.title": "crwdns2925:0crwdne2925:0",
  "filter.section.clearAll": "crwdns2927:0crwdne2927:0",
  "filter.section.dropHint": "crwdns2929:0crwdne2929:0",
  "filter.section.empty": "crwdns2931:0crwdne2931:0",
  "filter.valueDisplay.empty": "crwdns2933:0crwdne2933:0",
  "filter.valueDisplay.more": "crwdns2935:0crwdne2935:0",
  "filter.operator.equals.label": "crwdns2937:0crwdne2937:0",
  "filter.operator.equals.description": "crwdns2939:0crwdne2939:0",
  "filter.operator.notEquals.label": "crwdns2941:0crwdne2941:0",
  "filter.operator.notEquals.description": "crwdns2943:0crwdne2943:0",
  "filter.operator.contains.label": "crwdns2945:0crwdne2945:0",
  "filter.operator.contains.description": "crwdns2947:0crwdne2947:0",
  "filter.operator.notContains.label": "crwdns2949:0crwdne2949:0",
  "filter.operator.notContains.description": "crwdns2951:0crwdne2951:0",
  "filter.operator.startsWith.label": "crwdns2953:0crwdne2953:0",
  "filter.operator.startsWith.description": "crwdns2955:0crwdne2955:0",
  "filter.operator.notStartsWith.label": "crwdns2957:0crwdne2957:0",
  "filter.operator.notStartsWith.description": "crwdns2959:0crwdne2959:0",
  "filter.operator.endsWith.label": "crwdns2961:0crwdne2961:0",
  "filter.operator.endsWith.description": "crwdns2963:0crwdne2963:0",
  "filter.operator.notEndsWith.label": "crwdns2965:0crwdne2965:0",
  "filter.operator.notEndsWith.description": "crwdns2967:0crwdne2967:0",
  "filter.operator.like.label": "crwdns2969:0crwdne2969:0",
  "filter.operator.like.description": "crwdns2971:0crwdne2971:0",
  "filter.operator.notLike.label": "crwdns2973:0crwdne2973:0",
  "filter.operator.notLike.description": "crwdns2975:0crwdne2975:0",
  "filter.operator.ilike.label": "crwdns2977:0crwdne2977:0",
  "filter.operator.ilike.description": "crwdns2979:0crwdne2979:0",
  "filter.operator.gt.label": "crwdns2981:0crwdne2981:0",
  "filter.operator.gt.description": "crwdns2983:0crwdne2983:0",
  "filter.operator.gte.label": "crwdns2985:0crwdne2985:0",
  "filter.operator.gte.description": "crwdns2987:0crwdne2987:0",
  "filter.operator.lt.label": "crwdns2989:0crwdne2989:0",
  "filter.operator.lt.description": "crwdns2991:0crwdne2991:0",
  "filter.operator.lte.label": "crwdns2993:0crwdne2993:0",
  "filter.operator.lte.description": "crwdns2995:0crwdne2995:0",
  "filter.operator.between.label": "crwdns2997:0crwdne2997:0",
  "filter.operator.between.description": "crwdns2999:0crwdne2999:0",
  "filter.operator.notBetween.label": "crwdns3001:0crwdne3001:0",
  "filter.operator.notBetween.description": "crwdns3003:0crwdne3003:0",
  "filter.operator.in.label": "crwdns3005:0crwdne3005:0",
  "filter.operator.in.description": "crwdns3007:0crwdne3007:0",
  "filter.operator.notIn.label": "crwdns3009:0crwdne3009:0",
  "filter.operator.notIn.description": "crwdns3011:0crwdne3011:0",
  "filter.operator.set.label": "crwdns3013:0crwdne3013:0",
  "filter.operator.set.description": "crwdns3015:0crwdne3015:0",
  "filter.operator.notSet.label": "crwdns3017:0crwdne3017:0",
  "filter.operator.notSet.description": "crwdns3019:0crwdne3019:0",
  "filter.operator.isEmpty.label": "crwdns3021:0crwdne3021:0",
  "filter.operator.isEmpty.description": "crwdns3023:0crwdne3023:0",
  "filter.operator.isNotEmpty.label": "crwdns3025:0crwdne3025:0",
  "filter.operator.isNotEmpty.description": "crwdns3027:0crwdne3027:0",
  "filter.operator.inDateRange.label": "crwdns3029:0crwdne3029:0",
  "filter.operator.inDateRange.description": "crwdns3031:0crwdne3031:0",
  "filter.operator.beforeDate.label": "crwdns3033:0crwdne3033:0",
  "filter.operator.beforeDate.description": "crwdns3035:0crwdne3035:0",
  "filter.operator.afterDate.label": "crwdns3037:0crwdne3037:0",
  "filter.operator.afterDate.description": "crwdns3039:0crwdne3039:0",
  "filter.operator.regex.label": "crwdns3041:0crwdne3041:0",
  "filter.operator.regex.description": "crwdns3043:0crwdne3043:0",
  "filter.operator.notRegex.label": "crwdns3045:0crwdne3045:0",
  "filter.operator.notRegex.description": "crwdns3047:0crwdne3047:0",
  "filter.operator.arrayContains.label": "crwdns3049:0crwdne3049:0",
  "filter.operator.arrayContains.description": "crwdns3051:0crwdne3051:0",
  "filter.operator.arrayOverlaps.label": "crwdns3053:0crwdne3053:0",
  "filter.operator.arrayOverlaps.description": "crwdns3055:0crwdne3055:0",
  "filter.operator.arrayContained.label": "crwdns3057:0crwdne3057:0",
  "filter.operator.arrayContained.description": "crwdns3059:0crwdne3059:0",
  "dateRange.custom": "crwdns3061:0crwdne3061:0",
  "dateRange.today": "crwdns3063:0crwdne3063:0",
  "dateRange.yesterday": "crwdns3065:0crwdne3065:0",
  "dateRange.thisWeek": "crwdns3067:0crwdne3067:0",
  "dateRange.thisMonth": "crwdns3069:0crwdne3069:0",
  "dateRange.thisQuarter": "crwdns3071:0crwdne3071:0",
  "dateRange.thisYear": "crwdns3073:0crwdne3073:0",
  "dateRange.last7Days": "crwdns3075:0crwdne3075:0",
  "dateRange.last30Days": "crwdns3077:0crwdne3077:0",
  "dateRange.lastNDays": "crwdns3079:0crwdne3079:0",
  "dateRange.lastWeek": "crwdns3081:0crwdne3081:0",
  "dateRange.lastNWeeks": "crwdns3083:0crwdne3083:0",
  "dateRange.lastMonth": "crwdns3085:0crwdne3085:0",
  "dateRange.last12Months": "crwdns3087:0crwdne3087:0",
  "dateRange.lastNMonths": "crwdns3089:0crwdne3089:0",
  "dateRange.lastQuarter": "crwdns3091:0crwdne3091:0",
  "dateRange.lastNQuarters": "crwdns3093:0crwdne3093:0",
  "dateRange.lastYear": "crwdns3095:0crwdne3095:0",
  "dateRange.lastNYears": "crwdns3097:0crwdne3097:0",
  "timeGranularity.hour": "crwdns3099:0crwdne3099:0",
  "timeGranularity.day": "crwdns3101:0crwdne3101:0",
  "timeGranularity.week": "crwdns3103:0crwdne3103:0",
  "timeGranularity.month": "crwdns3105:0crwdne3105:0",
  "timeGranularity.quarter": "crwdns3107:0crwdne3107:0",
  "timeGranularity.year": "crwdns3109:0crwdne3109:0",
  "query.limit.label": "crwdns3111:0crwdne3111:0",
  "query.limit.clear": "crwdns3113:0crwdne3113:0",
  "chart.bar.label": "crwdns3115:0crwdne3115:0",
  "chart.bar.description": "crwdns3117:0crwdne3117:0",
  "chart.bar.useCase": "crwdns3119:0crwdne3119:0",
  "chart.line.label": "crwdns3121:0crwdne3121:0",
  "chart.line.description": "crwdns3123:0crwdne3123:0",
  "chart.line.useCase": "crwdns3125:0crwdne3125:0",
  "chart.area.label": "crwdns3127:0crwdne3127:0",
  "chart.area.description": "crwdns3129:0crwdne3129:0",
  "chart.area.useCase": "crwdns3131:0crwdne3131:0",
  "chart.pie.label": "crwdns3133:0crwdne3133:0",
  "chart.pie.description": "crwdns3135:0crwdne3135:0",
  "chart.pie.useCase": "crwdns3137:0crwdne3137:0",
  "chart.scatter.label": "crwdns3139:0crwdne3139:0",
  "chart.scatter.description": "crwdns3141:0crwdne3141:0",
  "chart.scatter.useCase": "crwdns3143:0crwdne3143:0",
  "chart.bubble.label": "crwdns3145:0crwdne3145:0",
  "chart.bubble.description": "crwdns3147:0crwdne3147:0",
  "chart.bubble.useCase": "crwdns3149:0crwdne3149:0",
  "chart.radar.label": "crwdns3151:0crwdne3151:0",
  "chart.radar.description": "crwdns3153:0crwdne3153:0",
  "chart.radar.useCase": "crwdns3155:0crwdne3155:0",
  "chart.radialBar.label": "crwdns3157:0crwdne3157:0",
  "chart.radialBar.description": "crwdns3159:0crwdne3159:0",
  "chart.radialBar.useCase": "crwdns3161:0crwdne3161:0",
  "chart.treemap.label": "crwdns3163:0crwdne3163:0",
  "chart.treemap.description": "crwdns3165:0crwdne3165:0",
  "chart.treemap.useCase": "crwdns3167:0crwdne3167:0",
  "chart.table.label": "crwdns3169:0crwdne3169:0",
  "chart.table.description": "crwdns3171:0crwdne3171:0",
  "chart.table.useCase": "crwdns3173:0crwdne3173:0",
  "chart.activityGrid.label": "crwdns3175:0crwdne3175:0",
  "chart.activityGrid.description": "crwdns3177:0crwdne3177:0",
  "chart.activityGrid.useCase": "crwdns3179:0crwdne3179:0",
  "chart.kpiNumber.label": "crwdns3181:0crwdne3181:0",
  "chart.kpiNumber.description": "crwdns3183:0crwdne3183:0",
  "chart.kpiNumber.useCase": "crwdns3185:0crwdne3185:0",
  "chart.kpiDelta.label": "crwdns3187:0crwdne3187:0",
  "chart.kpiDelta.description": "crwdns3189:0crwdne3189:0",
  "chart.kpiDelta.useCase": "crwdns3191:0crwdne3191:0",
  "chart.kpiText.label": "crwdns3193:0crwdne3193:0",
  "chart.kpiText.description": "crwdns3195:0crwdne3195:0",
  "chart.kpiText.useCase": "crwdns3197:0crwdne3197:0",
  "chart.markdown.label": "crwdns3199:0crwdne3199:0",
  "chart.markdown.description": "crwdns3201:0crwdne3201:0",
  "chart.markdown.useCase": "crwdns3203:0crwdne3203:0",
  "chart.funnel.label": "crwdns3205:0crwdne3205:0",
  "chart.funnel.description": "crwdns3207:0crwdne3207:0",
  "chart.funnel.useCase": "crwdns3209:0crwdne3209:0",
  "chart.sankey.label": "crwdns3211:0crwdne3211:0",
  "chart.sankey.description": "crwdns3213:0crwdne3213:0",
  "chart.sankey.useCase": "crwdns3215:0crwdne3215:0",
  "chart.sunburst.label": "crwdns3217:0crwdne3217:0",
  "chart.sunburst.description": "crwdns3219:0crwdne3219:0",
  "chart.sunburst.useCase": "crwdns3221:0crwdne3221:0",
  "chart.heatmap.label": "crwdns3223:0crwdne3223:0",
  "chart.heatmap.description": "crwdns3225:0crwdne3225:0",
  "chart.heatmap.useCase": "crwdns3227:0crwdne3227:0",
  "chart.retentionHeatmap.label": "crwdns3229:0crwdne3229:0",
  "chart.retentionHeatmap.description": "crwdns3231:0crwdne3231:0",
  "chart.retentionHeatmap.useCase": "crwdns3233:0crwdne3233:0",
  "chart.retentionCombined.label": "crwdns3235:0crwdne3235:0",
  "chart.retentionCombined.description": "crwdns3237:0crwdne3237:0",
  "chart.retentionCombined.useCase": "crwdns3239:0crwdne3239:0",
  "chart.boxPlot.label": "crwdns3241:0crwdne3241:0",
  "chart.boxPlot.description": "crwdns3243:0crwdne3243:0",
  "chart.boxPlot.useCase": "crwdns3245:0crwdne3245:0",
  "chart.waterfall.label": "crwdns3247:0crwdne3247:0",
  "chart.waterfall.description": "crwdns3249:0crwdne3249:0",
  "chart.waterfall.useCase": "crwdns3251:0crwdne3251:0",
  "chart.candlestick.label": "crwdns3253:0crwdne3253:0",
  "chart.candlestick.description": "crwdns3255:0crwdne3255:0",
  "chart.candlestick.useCase": "crwdns3257:0crwdne3257:0",
  "chart.measureProfile.label": "crwdns3259:0crwdne3259:0",
  "chart.measureProfile.description": "crwdns3261:0crwdne3261:0",
  "chart.measureProfile.useCase": "crwdns3263:0crwdne3263:0",
  "chart.gauge.label": "crwdns3265:0crwdne3265:0",
  "chart.gauge.description": "crwdns3267:0crwdne3267:0",
  "chart.gauge.useCase": "crwdns3269:0crwdne3269:0",
  "chart.config.chartType": "crwdns3271:0crwdne3271:0",
  "chart.config.loading": "crwdns3273:0crwdne3273:0",
  "chart.config.axisConfig": "crwdns3275:0crwdne3275:0",
  "chart.config.unassigned": "crwdns3277:0crwdne3277:0",
  "chart.config.unassignedHint": "crwdns3279:0crwdne3279:0",
  "chart.config.noFields": "crwdns3281:0crwdne3281:0",
  "chart.dropZone.xAxis.label": "crwdns3283:0crwdne3283:0",
  "chart.dropZone.xAxis.description": "crwdns3285:0crwdne3285:0",
  "chart.dropZone.xAxis.empty": "crwdns3287:0crwdne3287:0",
  "chart.dropZone.yAxis.label": "crwdns3289:0crwdne3289:0",
  "chart.dropZone.yAxis.description": "crwdns3291:0crwdne3291:0",
  "chart.dropZone.yAxis.empty": "crwdns3293:0crwdne3293:0",
  "chart.dropZone.series.label": "crwdns3295:0crwdne3295:0",
  "chart.dropZone.series.description": "crwdns3297:0crwdne3297:0",
  "chart.dropZone.series.empty": "crwdns3299:0crwdne3299:0",
  "chart.option.stacking.label": "crwdns3301:0crwdne3301:0",
  "chart.option.stacking.none": "crwdns3303:0crwdne3303:0",
  "chart.option.stacking.stacked": "crwdns3305:0crwdne3305:0",
  "chart.option.stacking.percent": "crwdns3307:0crwdne3307:0",
  "chart.option.stacking.description": "crwdns3309:0crwdne3309:0",
  "chart.option.target.label": "crwdns3311:0crwdne3311:0",
  "chart.option.target.description": "crwdns3313:0crwdne3313:0",
  "chart.option.connectNulls.label": "crwdns3315:0crwdne3315:0",
  "chart.option.connectNulls.description": "crwdns3317:0crwdne3317:0",
  "chart.option.showAllXLabels.label": "Wys Alle X-etikette",
  "chart.option.showAllXLabels.description": "Wys elke etiket op die X-as in plaas van oorvleuelende etikette outomaties te verberg",
  "chart.option.leftYAxisFormat.label": "crwdns3319:0crwdne3319:0",
  "chart.option.leftYAxisFormat.description": "crwdns3321:0crwdne3321:0",
  "chart.option.rightYAxisFormat.label": "crwdns3323:0crwdne3323:0",
  "chart.option.rightYAxisFormat.description": "crwdns3325:0crwdne3325:0",
  "chart.option.xAxisFormat.label": "crwdns3327:0crwdne3327:0",
  "chart.option.xAxisFormat.description": "crwdns3329:0crwdne3329:0",
  "chart.option.yAxisFormat.label": "crwdns3331:0crwdne3331:0",
  "chart.option.yAxisFormat.description": "crwdns3333:0crwdne3333:0",
  "chart.option.valueFormat.label": "crwdns3335:0crwdne3335:0",
  "chart.option.valueFormat.description": "crwdns3337:0crwdne3337:0",
  "chart.option.innerRadius.label": "crwdns3339:0crwdne3339:0",
  "chart.option.innerRadius.description": "crwdns3341:0crwdne3341:0",
  "chart.option.showLabels.label": "crwdns3343:0crwdne3343:0",
  "chart.option.showLabels.description": "crwdns3345:0crwdne3345:0",
  "chart.option.cellShape.label": "crwdns3347:0crwdne3347:0",
  "chart.option.cellShape.rectangle": "crwdns3349:0crwdne3349:0",
  "chart.option.cellShape.circle": "crwdns3351:0crwdne3351:0",
  "chart.option.funnelStyle.label": "crwdns3353:0crwdne3353:0",
  "chart.option.funnelStyle.bars": "crwdns3355:0crwdne3355:0",
  "chart.option.funnelStyle.funnel": "crwdns3357:0crwdne3357:0",
  "chart.option.funnelOrientation.label": "crwdns3359:0crwdne3359:0",
  "chart.option.funnelOrientation.horizontal": "crwdns3361:0crwdne3361:0",
  "chart.option.funnelOrientation.vertical": "crwdns3363:0crwdne3363:0",
  "chart.option.hideSummaryFooter.label": "crwdns3365:0crwdne3365:0",
  "chart.option.hideSummaryFooter.description": "crwdns3367:0crwdne3367:0",
  "chart.option.showConversion.label": "crwdns3369:0crwdne3369:0",
  "chart.option.showConversion.description": "crwdns3371:0crwdne3371:0",
  "chart.option.showAvgTime.label": "crwdns3373:0crwdne3373:0",
  "chart.option.showAvgTime.description": "crwdns3375:0crwdne3375:0",
  "chart.option.showMedianTime.label": "crwdns3377:0crwdne3377:0",
  "chart.option.showMedianTime.description": "crwdns3379:0crwdne3379:0",
  "chart.option.showP90Time.label": "crwdns3381:0crwdne3381:0",
  "chart.option.showP90Time.description": "crwdns3383:0crwdne3383:0",
  "chart.option.linkOpacity.label": "crwdns3385:0crwdne3385:0",
  "chart.option.linkOpacity.light": "crwdns3387:0crwdne3387:0",
  "chart.option.linkOpacity.medium": "crwdns3389:0crwdne3389:0",
  "chart.option.linkOpacity.dark": "crwdns3391:0crwdne3391:0",
  "chart.option.showNodeLabels.label": "crwdns3393:0crwdne3393:0",
  "chart.option.showNodeLabels.description": "crwdns3395:0crwdne3395:0",
  "chart.option.prefix.label": "crwdns3397:0crwdne3397:0",
  "chart.option.prefix.description": "crwdns3399:0crwdne3399:0",
  "chart.option.suffix.label": "crwdns3401:0crwdne3401:0",
  "chart.option.suffix.description": "crwdns3403:0crwdne3403:0",
  "chart.option.decimals.label": "crwdns3405:0crwdne3405:0",
  "chart.option.decimals.description": "crwdns3407:0crwdne3407:0",
  "chart.option.showHistogram.label": "crwdns3409:0crwdne3409:0",
  "chart.option.showHistogram.description": "crwdns3411:0crwdne3411:0",
  "chart.option.useLastCompletePeriod.label": "crwdns3413:0crwdne3413:0",
  "chart.option.useLastCompletePeriod.description": "crwdns3415:0crwdne3415:0",
  "chart.option.skipLastPeriod.label": "crwdns3417:0crwdne3417:0",
  "chart.option.skipLastPeriod.description": "crwdns3419:0crwdne3419:0",
  "chart.option.retentionDisplayMode.label": "crwdns3421:0crwdne3421:0",
  "chart.option.retentionDisplayMode.lineChart": "crwdns3423:0crwdne3423:0",
  "chart.option.retentionDisplayMode.heatmapTable": "crwdns3425:0crwdne3425:0",
  "chart.option.retentionDisplayMode.combined": "crwdns3427:0crwdne3427:0",
  "chart.option.showLegend.label": "crwdns3429:0crwdne3429:0",
  "chart.option.showLegend.description": "crwdns3431:0crwdne3431:0",
  "chart.option.showGrid.label": "crwdns3433:0crwdne3433:0",
  "chart.option.showGrid.description": "crwdns3435:0crwdne3435:0",
  "chart.option.showTooltip.label": "crwdns3437:0crwdne3437:0",
  "chart.option.showTooltip.description": "crwdns3439:0crwdne3439:0",
  "chart.option.priorPeriodStyle.label": "crwdns3441:0crwdne3441:0",
  "chart.option.priorPeriodStyle.dashed": "crwdns3443:0crwdne3443:0",
  "chart.option.priorPeriodStyle.dotted": "crwdns3445:0crwdne3445:0",
  "chart.option.priorPeriodStyle.solid": "crwdns3447:0crwdne3447:0",
  "chart.option.priorPeriodStyle.description": "crwdns3449:0crwdne3449:0",
  "chart.option.priorPeriodOpacity.label": "crwdns3451:0crwdne3451:0",
  "chart.option.priorPeriodOpacity.description": "crwdns3453:0crwdne3453:0",
  "chart.option.showTotal.label": "crwdns3455:0crwdne3455:0",
  "chart.option.showTotal.description": "crwdns3457:0crwdne3457:0",
  "chart.option.showConnectorLine.label": "crwdns3459:0crwdne3459:0",
  "chart.option.showConnectorLine.description": "crwdns3461:0crwdne3461:0",
  "chart.option.showDataLabels.label": "crwdns3463:0crwdne3463:0",
  "chart.option.showDataLabels.description": "crwdns3465:0crwdne3465:0",
  "chart.option.showReferenceLineAtZero.label": "crwdns3467:0crwdne3467:0",
  "chart.option.showReferenceLineAtZero.description": "crwdns3469:0crwdne3469:0",
  "chart.option.lineType.label": "crwdns3471:0crwdne3471:0",
  "chart.option.lineType.smooth": "crwdns3473:0crwdne3473:0",
  "chart.option.lineType.linear": "crwdns3475:0crwdne3475:0",
  "chart.option.lineType.step": "crwdns3477:0crwdne3477:0",
  "chart.option.lineType.description": "crwdns3479:0crwdne3479:0",
  "chart.option.rangeMode.label": "crwdns3481:0crwdne3481:0",
  "chart.option.rangeMode.ohlc": "crwdns3483:0crwdne3483:0",
  "chart.option.rangeMode.range": "crwdns3485:0crwdne3485:0",
  "chart.option.rangeMode.description": "crwdns3487:0crwdne3487:0",
  "chart.option.bullColor.label": "crwdns3489:0crwdne3489:0",
  "chart.option.bullColor.description": "crwdns3491:0crwdne3491:0",
  "chart.option.bearColor.label": "crwdns3493:0crwdne3493:0",
  "chart.option.bearColor.description": "crwdns3495:0crwdne3495:0",
  "chart.option.showWicks.label": "crwdns3497:0crwdne3497:0",
  "chart.option.showWicks.description": "crwdns3499:0crwdne3499:0",
  "chart.option.minValue.label": "crwdns3501:0crwdne3501:0",
  "chart.option.minValue.description": "crwdns3503:0crwdne3503:0",
  "chart.option.maxValue.label": "crwdns3505:0crwdne3505:0",
  "chart.option.maxValue.description": "crwdns3507:0crwdne3507:0",
  "chart.option.showCentreLabel.label": "crwdns3509:0crwdne3509:0",
  "chart.option.showCentreLabel.description": "crwdns3511:0crwdne3511:0",
  "chart.option.showPercentage.label": "crwdns3513:0crwdne3513:0",
  "chart.option.showPercentage.description": "crwdns3515:0crwdne3515:0",
  "chart.option.fitToWidth.label": "crwdns3517:0crwdne3517:0",
  "chart.option.fitToWidth.description": "crwdns3519:0crwdne3519:0",
  "chart.option.fontSize.label": "crwdns3521:0crwdne3521:0",
  "chart.option.fontSize.small": "crwdns3523:0crwdne3523:0",
  "chart.option.fontSize.medium": "crwdns3525:0crwdne3525:0",
  "chart.option.fontSize.large": "crwdns3527:0crwdne3527:0",
  "chart.option.alignment.label": "crwdns3529:0crwdne3529:0",
  "chart.option.alignment.left": "crwdns3531:0crwdne3531:0",
  "chart.option.alignment.center": "crwdns3533:0crwdne3533:0",
  "chart.option.alignment.right": "crwdns3535:0crwdne3535:0",
  "chart.option.hideHeader.label": "crwdns3537:0crwdne3537:0",
  "chart.option.hideHeader.description": "crwdns3539:0crwdne3539:0",
  "chart.option.transparentBackground.label": "crwdns3541:0crwdne3541:0",
  "chart.option.transparentBackground.description": "crwdns3543:0crwdne3543:0",
  "chart.option.autoHeight.label": "crwdns3545:0crwdne3545:0",
  "chart.option.autoHeight.description": "crwdns3547:0crwdne3547:0",
  "chart.option.accentBorder.label": "crwdns3549:0crwdne3549:0",
  "chart.option.accentBorder.none": "crwdns3551:0crwdne3551:0",
  "chart.option.accentBorder.left": "crwdns3553:0crwdne3553:0",
  "chart.option.accentBorder.top": "crwdns3555:0crwdne3555:0",
  "chart.option.accentBorder.bottom": "crwdns3557:0crwdne3557:0",
  "chart.option.accentBorder.description": "crwdns3559:0crwdne3559:0",
  "chart.configText.20_percent": "crwdns5247:0crwdne5247:0",
  "chart.configText.40_percent": "crwdns5249:0crwdne5249:0",
  "chart.configText.60_percent": "crwdns5251:0crwdne5251:0",
  "chart.configText.80_percent": "crwdns5253:0crwdne5253:0",
  "chart.configText.accent_color": "crwdns5255:0crwdne5255:0",
  "chart.configText.activity_measure": "crwdns5257:0crwdne5257:0",
  "chart.configText.add_2_or_more_measures_they_become_the_x_axis_categories_in_the_order_li": "crwdns5259:0crwdne5259:0",
  "chart.configText.add_an_accent_colored_border_on_one_side_of_the_content": "crwdns5261:0crwdne5261:0",
  "chart.configText.all_fields_to_display_as_columns": "crwdns5263:0crwdne5263:0",
  "chart.configText.array_of_value_0_1_fraction_color_bands_shown_as_outer_arc_markers": "crwdns5265:0crwdne5265:0",
  "chart.configText.axes_categories": "crwdns5267:0crwdne5267:0",
  "chart.configText.bubble_colour": "crwdns5269:0crwdne5269:0",
  "chart.configText.bubble_labels": "crwdns5271:0crwdne5271:0",
  "chart.configText.bubble_radius": "crwdns5273:0crwdne5273:0",
  "chart.configText.categories": "crwdns5275:0crwdne5275:0",
  "chart.configText.choose_how_to_visualize_retention_data": "crwdns5277:0crwdne5277:0",
  "chart.configText.color_bubbles_by_this_field_optional": "crwdns5279:0crwdne5279:0",
  "chart.configText.color_for_negative_changes_decreases": "crwdns5281:0crwdne5281:0",
  "chart.configText.color_for_positive_changes_increases": "crwdns5283:0crwdne5283:0",
  "chart.configText.color_from_the_dashboard_palette_for_headers_bullets_and_links": "crwdns5285:0crwdne5285:0",
  "chart.configText.color_from_the_dashboard_palette_for_the_kpi_value_text": "crwdns5287:0crwdne5287:0",
  "chart.configText.color_groups": "crwdns5289:0crwdne5289:0",
  "chart.configText.columns": "crwdns5291:0crwdne5291:0",
  "chart.configText.columns_x_axis": "crwdns5293:0crwdne5293:0",
  "chart.configText.count_at_each_step_auto_calculated": "crwdns5295:0crwdne5295:0",
  "chart.configText.count_of_entities_following_each_path": "crwdns5297:0crwdne5297:0",
  "chart.configText.current_value_to_display_on_the_gauge_e_g_current_equity_margin_used": "crwdns5299:0crwdne5299:0",
  "chart.configText.dimension_for_column_categories": "crwdns5301:0crwdne5301:0",
  "chart.configText.dimension_for_ordering_data_typically_time": "crwdns5303:0crwdne5303:0",
  "chart.configText.dimension_for_pie_slices": "crwdns5305:0crwdne5305:0",
  "chart.configText.dimension_for_row_categories": "crwdns5307:0crwdne5307:0",
  "chart.configText.dimension_labels_for_each_bar_segment_e_g_symbol_transaction_type": "crwdns5309:0crwdne5309:0",
  "chart.configText.dimension_optional": "crwdns5311:0crwdne5311:0",
  "chart.configText.dimension_to_color_points_by_category": "crwdns5313:0crwdne5313:0",
  "chart.configText.dimension_to_color_rectangles_by_category": "crwdns5315:0crwdne5315:0",
  "chart.configText.dimension_to_group_boxes_by_e_g_symbol_platform": "crwdns5317:0crwdne5317:0",
  "chart.configText.dimension_to_split_data_into_separate_profile_lines_e_g_symbol_platform": "crwdns5319:0crwdne5319:0",
  "chart.configText.dimensions_for_radar_axes": "crwdns5321:0crwdne5321:0",
  "chart.configText.dimensions_for_radial_segments": "crwdns5323:0crwdne5323:0",
  "chart.configText.dimensions_for_treemap_rectangles": "crwdns5325:0crwdne5325:0",
  "chart.configText.dimensions_to_create_multiple_radar_shapes": "crwdns5327:0crwdne5327:0",
  "chart.configText.dimensions_to_create_separate_lines": "crwdns5329:0crwdne5329:0",
  "chart.configText.dimensions_to_create_stacked_areas": "crwdns5331:0crwdne5331:0",
  "chart.configText.display_the_value_above_each_bar_segment": "crwdns5333:0crwdne5333:0",
  "chart.configText.display_value_at_each_data_point": "crwdns5335:0crwdne5335:0",
  "chart.configText.drop_1_measure_for_auto_mode_3_for_avg_stddev_median_mode_or_5_for_min_q": "crwdns5337:0crwdne5337:0",
  "chart.configText.drop_2_4_measures_in_order_open_close_high_low_ohlc_mode_for_range_mode_": "crwdns5339:0crwdne5339:0",
  "chart.configText.enter_markdown_text_supports_headers_bold_text_italic_text_links_text_ur": "crwdns5341:0urlcrwdne5341:0",
  "chart.configText.event_dimension_that_categorizes_flow_nodes": "crwdns5343:0crwdne5343:0",
  "chart.configText.event_type": "crwdns5345:0crwdne5345:0",
  "chart.configText.exclude_current_incomplete_period_from_aggregation_e_g_partial_week_mont": "crwdns5347:0crwdne5347:0",
  "chart.configText.exclude_current_incomplete_period_from_delta_calculation_e_g_partial_wee": "crwdns5349:0crwdne5349:0",
  "chart.configText.field_to_use_for_bubble_labels_and_identification": "crwdns5351:0crwdne5351:0",
  "chart.configText.flow_count": "crwdns5353:0crwdne5353:0",
  "chart.configText.hide_the_statistics_footer_below_the_chart": "crwdns5355:0crwdne5355:0",
  "chart.configText.hollow_center_size_0_percent_solid_pie_higher_donut_style": "crwdns5357:0crwdne5357:0",
  "chart.configText.horizontal_alignment_of_the_markdown_content": "crwdns5359:0crwdne5359:0",
  "chart.configText.horizontal_axis_position": "crwdns5361:0crwdne5361:0",
  "chart.configText.how_to_stack_multiple_area_series": "crwdns5363:0crwdne5363:0",
  "chart.configText.how_to_stack_multiple_bar_series": "crwdns5365:0crwdne5365:0",
  "chart.configText.markdown_content": "crwdns5367:0crwdne5367:0",
  "chart.configText.measure_for_rectangle_sizes": "crwdns5369:0crwdne5369:0",
  "chart.configText.measure_for_slice_sizes": "crwdns5371:0crwdne5371:0",
  "chart.configText.measure_for_y_position": "crwdns5373:0crwdne5373:0",
  "chart.configText.measure_or_dimension_for_x_position": "crwdns5375:0crwdne5375:0",
  "chart.configText.measure_that_determines_cell_color": "crwdns5377:0crwdne5377:0",
  "chart.configText.measure_to_display_as_kpi_number": "crwdns5379:0crwdne5379:0",
  "chart.configText.measure_to_display_in_the_kpi_text_template": "crwdns5381:0crwdne5381:0",
  "chart.configText.measure_to_track_changes_for": "crwdns5383:0crwdne5383:0",
  "chart.configText.measure_used_for_activity_intensity_color_coding": "crwdns5385:0crwdne5385:0",
  "chart.configText.measures_for_area_values": "crwdns5387:0crwdne5387:0",
  "chart.configText.measures_for_bar_heights": "crwdns5389:0crwdne5389:0",
  "chart.configText.measures_for_line_values": "crwdns5391:0crwdne5391:0",
  "chart.configText.measures_for_radar_values": "crwdns5393:0crwdne5393:0",
  "chart.configText.measures_for_radial_bar_lengths": "crwdns5395:0crwdne5395:0",
  "chart.configText.measures_x_axis_order": "crwdns5397:0crwdne5397:0",
  "chart.configText.negative_change_color": "crwdns5399:0crwdne5399:0",
  "chart.configText.none_pie": "crwdns5401:0crwdne5401:0",
  "chart.configText.number_formatting_for_cell_values_and_legend": "crwdns5403:0crwdne5403:0",
  "chart.configText.number_formatting_for_numeric_values": "crwdns5405:0crwdne5405:0",
  "chart.configText.number_formatting_for_size_values": "crwdns5407:0crwdne5407:0",
  "chart.configText.number_formatting_for_the_displayed_value_and_axis_labels": "crwdns5409:0crwdne5409:0",
  "chart.configText.number_formatting_for_the_price_axis": "crwdns5411:0crwdne5411:0",
  "chart.configText.number_formatting_for_the_value_axis": "crwdns5413:0crwdne5413:0",
  "chart.configText.number_formatting_for_the_y_axis": "crwdns5415:0crwdne5415:0",
  "chart.configText.number_formatting_for_x_axis_labels": "crwdns5417:0crwdne5417:0",
  "chart.configText.number_formatting_for_y_axis_and_values": "crwdns5419:0crwdne5419:0",
  "chart.configText.number_formatting_for_y_axis_labels": "crwdns5421:0crwdne5421:0",
  "chart.configText.number_of_decimal_places_to_display_for_numeric_values": "crwdns5423:0crwdne5423:0",
  "chart.configText.ohlc_measures_open_close_high_low": "crwdns5425:0crwdne5425:0",
  "chart.configText.opacity_of_flow_links": "crwdns5427:0crwdne5427:0",
  "chart.configText.overall_text_size_for_the_markdown_content": "crwdns5429:0crwdne5429:0",
  "chart.configText.positive_change_color": "crwdns5431:0crwdne5431:0",
  "chart.configText.rows_y_axis": "crwdns5433:0crwdne5433:0",
  "chart.configText.series_color_groups": "crwdns5435:0crwdne5435:0",
  "chart.configText.series_multiple_lines": "crwdns5437:0crwdne5437:0",
  "chart.configText.series_multiple_shapes": "crwdns5439:0crwdne5439:0",
  "chart.configText.series_split_into_multiple_lines": "crwdns5441:0crwdne5441:0",
  "chart.configText.series_stack_areas": "crwdns5443:0crwdne5443:0",
  "chart.configText.show_series_legend_only_visible_with_a_series_dimension": "crwdns5445:0crwdne5445:0",
  "chart.configText.show_the_color_intensity_legend": "crwdns5447:0crwdne5447:0",
  "chart.configText.show_the_legend_for_breakdown_segments": "crwdns5449:0crwdne5449:0",
  "chart.configText.single_measure_whose_values_are_summed_cumulatively": "crwdns5451:0crwdne5451:0",
  "chart.configText.size": "crwdns5453:0crwdne5453:0",
  "chart.configText.size_of_bubbles_based_on_this_measure": "crwdns5455:0crwdne5455:0",
  "chart.configText.size_of_the_center_hole_0_for_full_circle": "crwdns5457:0crwdne5457:0",
  "chart.configText.step_count": "crwdns5459:0crwdne5459:0",
  "chart.configText.step_name": "crwdns5461:0crwdne5461:0",
  "chart.configText.step_names_auto_populated_from_funnel_steps": "crwdns5463:0crwdne5463:0",
  "chart.configText.target_value_to_compare_against_first_value_used_if_multiple_provided": "crwdns5465:0crwdne5465:0",
  "chart.configText.template_for_displaying_the_text_use_value_to_insert_the_measure_value": "crwdns5467:0${value}crwdne5467:0",
  "chart.configText.text_template": "crwdns5469:0crwdne5469:0",
  "chart.configText.threshold_bands": "crwdns5471:0crwdne5471:0",
  "chart.configText.time_dimension": "crwdns5473:0crwdne5473:0",
  "chart.configText.time_dimension_or_category_for_each_candle_e_g_date_symbol": "crwdns5475:0crwdne5475:0",
  "chart.configText.time_dimensions_or_dimensions_for_x_axis": "crwdns5477:0crwdne5477:0",
  "chart.configText.time_field_that_determines_grid_structure_granularity_affects_layout": "crwdns5479:0crwdne5479:0",
  "chart.configText.value": "crwdns5481:0crwdne5481:0",
  "chart.configText.value_color": "crwdns5483:0crwdne5483:0",
  "chart.configText.value_color_intensity": "crwdns5485:0crwdne5485:0",
  "chart.configText.value_measure": "crwdns5487:0crwdne5487:0",
  "chart.configText.values": "crwdns5489:0crwdne5489:0",
  "chart.configText.vertical_axis_position": "crwdns5491:0crwdne5491:0",
  "chart.configText.visualization_style": "crwdns5493:0crwdne5493:0",
  "chart.configText.x_axis_groups": "crwdns5495:0crwdne5495:0",
  "chart.configText.x_axis_time_categories": "crwdns5497:0crwdne5497:0",
  "chart.configText.x_axis_time_category": "crwdns5499:0crwdne5499:0",
  "chart.configText.y_axis": "crwdns5501:0crwdne5501:0",
  "chart.configText.y_axis_measures": "crwdns5503:0crwdne5503:0",
  "chart.configText.y_axis_value": "crwdns5505:0crwdne5505:0",
  "display.loading": "crwdns3561:0crwdne3561:0",
  "display.noOptions": "crwdns3563:0crwdne3563:0",
  "display.heading": "crwdns3565:0crwdne3565:0",
  "results.loading.title": "crwdns3567:0crwdne3567:0",
  "results.loading.subtitle": "crwdns3569:0crwdne3569:0",
  "results.error.title": "crwdns3571:0crwdne3571:0",
  "results.error.subtitle": "crwdns3573:0crwdne3573:0",
  "results.waiting.title": "crwdns3575:0crwdne3575:0",
  "results.waiting.subtitle": "crwdns3577:0crwdne3577:0",
  "results.needsRefresh.title": "crwdns3579:0crwdne3579:0",
  "results.needsRefresh.subtitle": "crwdns3581:0crwdne3581:0",
  "results.needsRefresh.runButton": "crwdns3583:0crwdne3583:0",
  "results.empty.query": "crwdns3585:0crwdne3585:0",
  "results.empty.retention": "crwdns3587:0crwdne3587:0",
  "results.empty.funnel": "crwdns3589:0crwdne3589:0",
  "results.empty.flow": "crwdns3591:0crwdne3591:0",
  "results.empty.title": "crwdns3593:0crwdne3593:0",
  "results.ai.button": "crwdns3595:0crwdne3595:0",
  "results.noData.title": "crwdns3597:0crwdne3597:0",
  "results.noData.subtitle": "crwdns3599:0crwdne3599:0",
  "results.chart.noData": "crwdns3601:0crwdne3601:0",
  "results.chart.noDataHint": "crwdns3603:0crwdne3603:0",
  "results.chart.unsupported": "crwdns3605:0crwdne3605:0",
  "results.refreshing": "crwdns3607:0crwdne3607:0",
  "results.header.rows": "crwdns3609:0crwdne3609:0",
  "results.header.row": "crwdns3611:0crwdne3611:0",
  "results.header.stale": "crwdns3613:0crwdne3613:0",
  "results.header.failed": "crwdns3615:0crwdne3615:0",
  "results.header.executing": "crwdns3617:0crwdne3617:0",
  "results.header.noResults": "crwdns3619:0crwdne3619:0",
  "results.view.chart": "crwdns3621:0crwdne3621:0",
  "results.view.merged": "crwdns3623:0crwdne3623:0",
  "results.warning.largeDataset": "crwdns3625:0crwdne3625:0",
  "results.warning.configChanged": "crwdns3627:0crwdne3627:0",
  "results.warning.refreshNow": "crwdns3629:0crwdne3629:0",
  "results.share.copied": "crwdns3631:0crwdne3631:0",
  "results.share.noChart": "crwdns3633:0crwdne3633:0",
  "server.errors.dbNotConfigured": "crwdns3635:0crwdne3635:0",
  "server.errors.cubeNotFound": "crwdns3637:0{cubeName}crwdne3637:0",
  "server.errors.noCubesInQuery": "crwdns3639:0crwdne3639:0",
  "server.errors.dbAdapterRequired": "crwdns3641:0crwdne3641:0",
  "server.errors.rlsRequiresTransactions": "crwdns3643:0crwdne3643:0",
  "server.errors.queryExecutionFailed": "crwdns3645:0{message}crwdne3645:0",
  "server.errors.queryExecutionUnknown": "crwdns3647:0crwdne3647:0",
  "server.errors.noCompareDateRange": "crwdns3649:0crwdne3649:0",
  "server.errors.compareDateRangeInvalid": "crwdns3651:0crwdne3651:0",
  "server.errors.funnelValidationFailed": "crwdns3653:0{errors}crwdne3653:0",
  "server.errors.flowValidationFailed": "crwdns3655:0{errors}crwdne3655:0",
  "server.errors.retentionValidationFailed": "crwdns3657:0{errors}crwdne3657:0",
  "server.errors.cubeRefUnresolved": "crwdns3659:0{cubeName}crwdnd3659:0{joinName}crwdnd3659:0{targetCube}crwdne3659:0",
  "server.errors.unresolvedCubeRefs": "crwdns3661:0{details}crwdne3661:0",
  "server.errors.calculatedMeasureValidation": "crwdns3663:0{cubeName}crwdnd3663:0{details}crwdne3663:0",
  "server.errors.queryValidationFailed": "crwdns3665:0{errors}crwdne3665:0",
  "server.errors.queryContainsMultipleModes": "crwdns3667:0{modes}crwdne3667:0",
  "server.errors.primaryCubeNotFound": "crwdns3669:0{cubeName}crwdne3669:0",
  "server.errors.noJoinPath": "crwdns3671:0{fromCube}crwdnd3671:0{toCube}crwdne3671:0",
  "server.errors.cubeNotFoundForMeasure": "crwdns3673:0{cubeName}crwdnd3673:0{measure}crwdne3673:0",
  "server.errors.cubeNotFoundForDimension": "crwdns3675:0{cubeName}crwdnd3675:0{dimension}crwdne3675:0",
  "server.errors.cubeNotFoundForTimeDimension": "crwdns3677:0{cubeName}crwdnd3677:0{timeDimension}crwdne3677:0",
  "server.errors.invalidFunnelConfig": "crwdns3679:0crwdne3679:0",
  "server.errors.invalidFlowConfig": "crwdns3681:0crwdne3681:0",
  "server.errors.invalidRetentionConfig": "crwdns3683:0crwdne3683:0",
  "server.errors.llmInitFailed": "crwdns3685:0crwdne3685:0",
  "server.validation.ai.bindingKeyRequired.flow": "crwdns3687:0crwdne3687:0",
  "server.validation.ai.bindingKeyRequired.funnel": "crwdns3689:0crwdne3689:0",
  "server.validation.ai.bindingKeyRequired.retention": "crwdns3691:0crwdne3691:0",
  "server.validation.ai.cubeNotFoundInFilter": "crwdns3693:0{cubeName}crwdne3693:0",
  "server.validation.ai.cubeNotFoundWithAvailable": "crwdns3695:0{cubeName}crwdne3695:0",
  "server.validation.ai.cubeNotFoundWithSuggestion": "crwdns3697:0{cubeName}crwdne3697:0",
  "server.validation.ai.dimensionNotFoundWithAvailable": "crwdns3699:0{dimensionName}crwdnd3699:0{cubeName}crwdne3699:0",
  "server.validation.ai.dimensionNotFoundWithSuggestion": "crwdns3701:0{dimensionName}crwdnd3701:0{cubeName}crwdne3701:0",
  "server.validation.ai.dimensionNotTimeType": "crwdns3703:0{dimension}crwdnd3703:0{type}crwdne3703:0",
  "server.validation.ai.emptyQuery": "crwdns3705:0crwdne3705:0",
  "server.validation.ai.eventDimensionRequired": "crwdns3707:0crwdne3707:0",
  "server.validation.ai.filterFieldNotFound": "crwdns3709:0{fieldName}crwdnd3709:0{cubeName}crwdne3709:0",
  "server.validation.ai.filterFieldNotFoundWithSuggestion": "crwdns3711:0{fieldName}crwdnd3711:0{cubeName}crwdne3711:0",
  "server.validation.ai.funnelRequiresSteps": "crwdns3713:0crwdne3713:0",
  "server.validation.ai.funnelStepsRequired": "crwdns3715:0crwdne3715:0",
  "server.validation.ai.granularityNotSpecified": "crwdns3717:0crwdne3717:0",
  "server.validation.ai.invalidDimensionFormat": "crwdns3719:0{dimension}crwdne3719:0",
  "server.validation.ai.invalidFilterMemberFormat": "crwdns3721:0{member}crwdne3721:0",
  "server.validation.ai.invalidMeasureFormat": "crwdns3723:0{measure}crwdne3723:0",
  "server.validation.ai.measureNotFoundWithAvailable": "crwdns3725:0{measureName}crwdnd3725:0{cubeName}crwdne3725:0",
  "server.validation.ai.measureNotFoundWithSuggestion": "crwdns3727:0{measureName}crwdnd3727:0{cubeName}crwdne3727:0",
  "server.validation.ai.performanceManyDimensions": "crwdns3729:0{count}crwdne3729:0",
  "server.validation.ai.performanceManyMeasures": "crwdns3731:0{count}crwdne3731:0",
  "server.validation.ai.periodsNotSpecified": "crwdns3733:0crwdne3733:0",
  "server.validation.ai.retentionTimeDimensionRequired": "crwdns3735:0crwdne3735:0",
  "server.validation.ai.stepMissingName": "crwdns3737:0{step}crwdne3737:0",
  "server.validation.ai.stepsBothMissing": "crwdns3739:0crwdne3739:0",
  "server.validation.ai.suggestAddDimensionFilters": "crwdns3741:0crwdne3741:0",
  "server.validation.ai.suggestAddStepNames": "crwdns3743:0crwdne3743:0",
  "server.validation.ai.suggestSetSteps": "crwdns3745:0crwdne3745:0",
  "server.validation.ai.suggestSpecifyGranularity": "crwdns3747:0crwdne3747:0",
  "server.validation.ai.suggestSpecifyPeriods": "crwdns3749:0crwdne3749:0",
  "server.validation.ai.suggestSplitQueries": "crwdns3751:0crwdne3751:0",
  "server.validation.ai.suggestUseTimeDimension": "crwdns3753:0crwdne3753:0",
  "server.validation.ai.timeDimensionRequired.flow": "crwdns3755:0crwdne3755:0",
  "server.validation.ai.timeDimensionRequired.funnel": "crwdns3757:0crwdne3757:0",
  "server.validation.chart.barNeedsDimension": "crwdns3759:0crwdne3759:0",
  "server.validation.chart.barXAxisRequired": "crwdns3761:0crwdne3761:0",
  "server.validation.chart.dropZoneRequired": "crwdns3763:0{key}crwdnd3763:0{chartType}crwdnd3763:0{label}crwdnd3763:0{acceptDesc}crwdne3763:0",
  "server.validation.chart.seriesDuplicatesXAxis": "crwdns3765:0{duplicates}crwdne3765:0",
  "server.validation.flow.bindingKeyCubeNotFound": "crwdns3767:0{cubeName}crwdne3767:0",
  "server.validation.flow.bindingKeyDimNotFound": "crwdns3769:0{dimName}crwdnd3769:0{cubeName}crwdne3769:0",
  "server.validation.flow.bindingKeyMappingCubeNotFound": "crwdns3771:0{cubeName}crwdne3771:0",
  "server.validation.flow.eventDimCubeNotFound": "crwdns3773:0{cubeName}crwdne3773:0",
  "server.validation.flow.eventDimNotFound": "crwdns3775:0{dimName}crwdnd3775:0{cubeName}crwdne3775:0",
  "server.validation.flow.eventDimRequired": "crwdns3777:0crwdne3777:0",
  "server.validation.flow.highStepDepthWarning": "crwdns3779:0crwdne3779:0",
  "server.validation.flow.invalidBindingKeyFormat": "crwdns3781:0{bindingKey}crwdne3781:0",
  "server.validation.flow.invalidEventDimFormat": "crwdns3783:0{eventDimension}crwdne3783:0",
  "server.validation.flow.invalidJoinStrategy": "crwdns3785:0{joinStrategy}crwdne3785:0",
  "server.validation.flow.invalidTimeDimFormat": "crwdns3787:0{timeDimension}crwdne3787:0",
  "server.validation.flow.lateralNotSupported": "crwdns3789:0crwdne3789:0",
  "server.validation.flow.lateralNotSupportedExec": "crwdns3791:0crwdne3791:0",
  "server.validation.flow.sqliteNotSupported": "crwdns3793:0crwdne3793:0",
  "server.validation.flow.startingStepFilterRequired": "crwdns3795:0crwdne3795:0",
  "server.validation.flow.startingStepNameMissing": "crwdns3797:0crwdne3797:0",
  "server.validation.flow.startingStepRequired": "crwdns3799:0crwdne3799:0",
  "server.validation.flow.stepsBeforeRange": "crwdns3801:0{value}crwdne3801:0",
  "server.validation.flow.stepsAfterRange": "crwdns3803:0{value}crwdne3803:0",
  "server.validation.flow.timeDimCubeNotFound": "crwdns3805:0{cubeName}crwdne3805:0",
  "server.validation.flow.timeDimNotFound": "crwdns3807:0{dimName}crwdnd3807:0{cubeName}crwdne3807:0",
  "server.validation.funnel.bindingKeyCubeNotFound": "crwdns3809:0{cubeName}crwdne3809:0",
  "server.validation.funnel.bindingKeyDimNotFound": "crwdns3811:0{dimName}crwdnd3811:0{cubeName}crwdne3811:0",
  "server.validation.funnel.bindingKeyMappingCubeNotFound": "crwdns3813:0{cubeName}crwdne3813:0",
  "server.validation.funnel.invalidBindingKeyFormat": "crwdns3815:0{bindingKey}crwdne3815:0",
  "server.validation.funnel.invalidTimeDimFormat": "crwdns3817:0{timeDimension}crwdne3817:0",
  "server.validation.funnel.minSteps": "crwdns3819:0crwdne3819:0",
  "server.validation.funnel.stepCubeNotFound": "crwdns3821:0{step}crwdnd3821:0{cube}crwdne3821:0",
  "server.validation.funnel.stepFilterCubeNotFound": "crwdns3823:0{step}crwdnd3823:0{cubeName}crwdne3823:0",
  "server.validation.funnel.stepFilterIsMeasure": "crwdns3825:0{step}crwdnd3825:0{member}crwdne3825:0",
  "server.validation.funnel.stepFilterMemberNotFound": "crwdns3827:0{step}crwdnd3827:0{field}crwdnd3827:0{cubeName}crwdne3827:0",
  "server.validation.funnel.stepFilterNoJoinPath": "crwdns3829:0{step}crwdnd3829:0{member}crwdnd3829:0{stepCube}crwdne3829:0",
  "server.validation.funnel.stepMustHaveName": "crwdns3831:0{step}crwdne3831:0",
  "server.validation.funnel.stepTimeToConvertFormat": "crwdns3833:0{step}crwdnd3833:0{value}crwdne3833:0",
  "server.validation.funnel.timeDimCubeNotFound": "crwdns3835:0{cubeName}crwdne3835:0",
  "server.validation.funnel.timeDimNotFound": "crwdns3837:0{dimName}crwdnd3837:0{cubeName}crwdne3837:0",
  "server.validation.retention.bindingKeyCubeNotFound": "crwdns3839:0{cubeName}crwdne3839:0",
  "server.validation.retention.bindingKeyDimNotFound": "crwdns3841:0{dimName}crwdnd3841:0{cubeName}crwdne3841:0",
  "server.validation.retention.bindingKeyMappingCubeNotFound": "crwdns3843:0{cubeName}crwdne3843:0",
  "server.validation.retention.breakdownDimCubeNotFound": "crwdns3845:0{cubeName}crwdne3845:0",
  "server.validation.retention.breakdownDimNotFound": "crwdns3847:0{dimName}crwdnd3847:0{cubeName}crwdne3847:0",
  "server.validation.retention.cubeNotFound": "crwdns3849:0{cubeName}crwdne3849:0",
  "server.validation.retention.dateRangeEndRequired": "crwdns3851:0crwdne3851:0",
  "server.validation.retention.dateRangeInvalidEnd": "crwdns3853:0crwdne3853:0",
  "server.validation.retention.dateRangeInvalidStart": "crwdns3855:0crwdne3855:0",
  "server.validation.retention.dateRangeRequired": "crwdns3857:0crwdne3857:0",
  "server.validation.retention.dateRangeStartBeforeEnd": "crwdns3859:0crwdne3859:0",
  "server.validation.retention.dateRangeStartRequired": "crwdns3861:0crwdne3861:0",
  "server.validation.retention.invalidBindingKeyFormat": "crwdns3863:0{bindingKey}crwdne3863:0",
  "server.validation.retention.invalidBreakdownDimFormat": "crwdns3865:0{dimension}crwdne3865:0",
  "server.validation.retention.invalidGranularity": "crwdns3867:0{granularity}crwdne3867:0",
  "server.validation.retention.invalidRetentionType": "crwdns3869:0{retentionType}crwdne3869:0",
  "server.validation.retention.invalidTimeDimFormat": "crwdns3871:0{timeDimension}crwdne3871:0",
  "server.validation.retention.noBindingKeyMapping": "crwdns3873:0{cubeName}crwdne3873:0",
  "server.validation.retention.periodsMax": "crwdns3875:0crwdne3875:0",
  "server.validation.retention.periodsMin": "crwdns3877:0crwdne3877:0",
  "server.validation.retention.timeDimNotFound": "crwdns3879:0{dimName}crwdne3879:0",
  "server.validation.calculatedMeasure.mustHaveCalculatedSql": "crwdns3881:0{cubeName}crwdnd3881:0{fieldName}crwdne3881:0",
  "server.validation.calculatedMeasure.invalidSyntax": "crwdns3883:0{cubeName}crwdnd3883:0{fieldName}crwdnd3883:0{errors}crwdne3883:0",
  "server.validation.calculatedMeasure.circularDependency": "crwdns3885:0{cycle}crwdne3885:0",
  "server.validation.query.multipleQueryModes": "crwdns3887:0{modes}crwdne3887:0",
  "server.validation.query.funnelBindingKeyCubeNotFound": "crwdns3889:0{cubeName}crwdne3889:0",
  "server.validation.query.flowBindingKeyCubeNotFound": "crwdns3891:0{cubeName}crwdne3891:0",
  "server.validation.query.retentionCubeNotFound": "crwdns3893:0{cubeName}crwdne3893:0",
  "server.validation.query.retentionBindingKeyCubeNotFound": "crwdns3895:0{cubeName}crwdne3895:0",
  "server.validation.query.retentionBreakdownCubeNotFound": "crwdns3897:0{cubeName}crwdne3897:0",
  "server.validation.query.invalidMeasureFormat": "crwdns3899:0{measure}crwdne3899:0",
  "server.validation.query.cubeNotFoundForMeasure": "crwdns3901:0{cubeName}crwdnd3901:0{measure}crwdne3901:0",
  "server.validation.query.measureNotFound": "crwdns3903:0{fieldName}crwdnd3903:0{cubeName}crwdnd3903:0{hint}crwdne3903:0",
  "server.validation.query.invalidDimensionFormat": "crwdns3905:0{dimension}crwdne3905:0",
  "server.validation.query.cubeNotFoundForDimension": "crwdns3907:0{cubeName}crwdnd3907:0{dimension}crwdne3907:0",
  "server.validation.query.dimensionNotFound": "crwdns3909:0{fieldName}crwdnd3909:0{cubeName}crwdnd3909:0{hint}crwdne3909:0",
  "server.validation.query.invalidTimeDimensionFormat": "crwdns3911:0{dimension}crwdne3911:0",
  "server.validation.query.cubeNotFoundForTimeDimension": "crwdns3913:0{cubeName}crwdnd3913:0{dimension}crwdne3913:0",
  "server.validation.query.timeDimensionNotFound": "crwdns3915:0{fieldName}crwdnd3915:0{cubeName}crwdne3915:0",
  "server.validation.query.mustReferenceAtLeastOneCube": "crwdns3917:0crwdne3917:0",
  "server.validation.query.ungroupedRequiresDimension": "crwdns3919:0crwdne3919:0",
  "server.validation.query.ungroupedIncompatibleFunnel": "crwdns3921:0crwdne3921:0",
  "server.validation.query.ungroupedIncompatibleFlow": "crwdns3923:0crwdne3923:0",
  "server.validation.query.ungroupedIncompatibleRetention": "crwdns3925:0crwdne3925:0",
  "server.validation.query.ungroupedIncompatibleCompareDateRange": "crwdns3927:0crwdne3927:0",
  "server.validation.query.ungroupedIncompatibleFillMissingDates": "crwdns3929:0crwdne3929:0",
  "server.validation.query.filterMustHaveMember": "crwdns3931:0crwdne3931:0",
  "server.validation.query.invalidFilterMemberFormat": "crwdns3933:0{member}crwdne3933:0",
  "server.validation.query.cubeNotFoundForFilter": "crwdns3935:0{cubeName}crwdnd3935:0{member}crwdne3935:0",
  "server.validation.query.filterFieldNotFound": "crwdns3937:0{fieldName}crwdnd3937:0{cubeName}crwdnd3937:0{hint}crwdne3937:0",
  "server.errors.funnel.cubeNotFoundForStep": "crwdns3939:0{cube}crwdne3939:0",
  "server.errors.funnel.cubeNotFoundForBindingKey": "crwdns3941:0{bindingKey}crwdne3941:0",
  "server.errors.funnel.cannotResolveCubeForStep": "crwdns3943:0crwdne3943:0",
  "server.errors.funnel.bindingKeyDimNotFound": "crwdns3945:0{bindingKey}crwdne3945:0",
  "server.errors.funnel.noBindingKeyMapping": "crwdns3947:0{cubeName}crwdne3947:0",
  "server.errors.funnel.bindingKeyMappingDimNotFound": "crwdns3949:0{dimension}crwdne3949:0",
  "server.errors.funnel.timeDimNotFound": "crwdns3951:0{timeDimension}crwdne3951:0",
  "server.errors.funnel.noTimeDimMapping": "crwdns3953:0{cubeName}crwdne3953:0",
  "server.errors.funnel.timeDimMappingNotFound": "crwdns3955:0{dimension}crwdne3955:0",
  "server.errors.flow.cannotResolveCube": "crwdns3957:0crwdne3957:0",
  "server.errors.flow.cubeNotFound": "crwdns3959:0{cubeName}crwdne3959:0",
  "server.errors.flow.bindingKeyDimNotFound": "crwdns3961:0{bindingKey}crwdne3961:0",
  "server.errors.flow.noBindingKeyMapping": "crwdns3963:0{cubeName}crwdne3963:0",
  "server.errors.flow.bindingKeyMappingDimNotFound": "crwdns3965:0{dimension}crwdne3965:0",
  "server.errors.flow.timeDimNotFound": "crwdns3967:0{timeDimension}crwdne3967:0",
  "server.errors.flow.noTimeDimMapping": "crwdns3969:0{cubeName}crwdne3969:0",
  "server.errors.flow.timeDimMappingNotFound": "crwdns3971:0{dimension}crwdne3971:0",
  "server.errors.flow.eventDimNotFound": "crwdns3973:0{eventDimension}crwdne3973:0",
  "server.validation.template.emptyReference": "crwdns3975:0crwdne3975:0",
  "server.validation.template.invalidMemberReference": "crwdns3977:0{ref}crwdne3977:0",
  "server.validation.template.multipleDots": "crwdns3979:0{ref}crwdne3979:0",
  "server.validation.template.nestedBraces": "crwdns3981:0crwdne3981:0",
  "server.validation.template.substituteTargetCubeNotFound": "crwdns3983:0{ref}crwdnd3983:0{cubeName}crwdne3983:0",
  "server.validation.template.substituteMeasureNotResolved": "crwdns3985:0{ref}crwdnd3985:0{measureName}crwdne3985:0",
  "server.validation.template.unmatchedClosingBrace": "crwdns3987:0{position}crwdne3987:0",
  "server.validation.template.unmatchedOpeningBrace": "crwdns3989:0crwdne3989:0",
  "notebook.aiAssistant": "crwdns3999:0crwdne3999:0",
  "notebook.saveAsDashboard": "crwdns4001:0crwdne4001:0",
  "notebook.saveAsDashboardTitle": "crwdns4003:0crwdne4003:0",
  "notebook.clearTitle": "crwdns4005:0crwdne4005:0",
  "notebook.feedbackThanks": "crwdns4007:0crwdne4007:0",
  "notebook.feedbackQuestion": "crwdns4009:0crwdne4009:0",
  "notebook.feedbackYes": "crwdns4011:0crwdne4011:0",
  "notebook.feedbackNo": "crwdns4013:0crwdne4013:0",
  "notebook.thinking": "crwdns4015:0crwdne4015:0",
  "notebook.emptyState.title": "crwdns4017:0crwdne4017:0",
  "notebook.emptyState.description": "crwdns4019:0crwdne4019:0",
  "notebook.emptyState.example1": "crwdns4021:0crwdne4021:0",
  "notebook.emptyState.example2": "crwdns4023:0crwdne4023:0",
  "notebook.emptyState.example3": "crwdns4025:0crwdne4025:0",
  "notebook.saveAsDashboardPrompt": "crwdns4027:0crwdne4027:0",
  "notebook.chatInput.placeholder": "crwdns4029:0crwdne4029:0",
  "notebook.chatInput.stop": "crwdns4031:0crwdne4031:0",
  "notebook.chatInput.continue": "crwdns4033:0crwdne4033:0",
  "notebook.chatInput.send": "crwdns4035:0crwdne4035:0",
  "notebook.canvas.emptyTitle": "crwdns4037:0crwdne4037:0",
  "notebook.canvas.emptyDescription": "crwdns4039:0crwdne4039:0",
  "notebook.canvas.editVisualization": "crwdns4041:0crwdne4041:0",
  "notebook.canvas.update": "crwdns4043:0crwdne4043:0",
  "notebook.collapsed.noBlocks": "crwdns4045:0crwdne4045:0",
  "notebook.collapsed.expandNotebook": "crwdns4047:0crwdne4047:0",
  "notebook.collapsed.expandChat": "crwdns4049:0crwdne4049:0",
  "notebook.collapsed.aiChat": "crwdns4051:0crwdne4051:0",
  "notebook.collapsed.markdown": "crwdns4053:0crwdne4053:0",
  "schema.loading": "crwdns4055:0crwdne4055:0",
  "schema.error": "crwdns4057:0crwdne4057:0",
  "schema.noCubes": "crwdns4059:0crwdne4059:0",
  "schema.noCubesHint": "crwdns4061:0crwdne4061:0",
  "schema.computingLayout": "crwdns4063:0crwdne4063:0",
  "schema.searchPlaceholder": "crwdns4065:0crwdne4065:0",
  "schema.autoLayout": "crwdns4067:0crwdne4067:0",
  "schema.missingDeps.title": "crwdns4069:0crwdne4069:0",
  "schema.missingDeps.description": "crwdns4071:0crwdne4071:0",
  "schema.loadingVisualization": "crwdns4073:0crwdne4073:0",
  "schema.measures": "crwdns4075:0{count}crwdne4075:0",
  "schema.timeDimensions": "crwdns4077:0{count}crwdne4077:0",
  "schema.dimensions": "crwdns4079:0{count}crwdne4079:0",
  "schema.cubeInfo": "crwdns4081:0crwdne4081:0",
  "dataBrowser.selectCube": "crwdns4083:0crwdne4083:0",
  "dataBrowser.selectCubeHint": "crwdns4085:0crwdne4085:0",
  "dataBrowser.loadingData": "crwdns4087:0crwdne4087:0",
  "dataBrowser.noData": "crwdns4089:0crwdne4089:0",
  "dataBrowser.noRows": "crwdns4091:0crwdne4091:0",
  "dataBrowser.toolbar.filters": "crwdns4093:0crwdne4093:0",
  "dataBrowser.toolbar.columns": "crwdns4095:0crwdne4095:0",
  "dataBrowser.toolbar.rows": "crwdns4097:0{count}crwdne4097:0",
  "dataBrowser.sidebar.cubes": "crwdns4099:0crwdne4099:0",
  "dataBrowser.sidebar.searchPlaceholder": "crwdns4101:0crwdne4101:0",
  "dataBrowser.sidebar.noCubes": "crwdns4103:0crwdne4103:0",
  "queryAnalysis.summary": "crwdns4105:0crwdne4105:0",
  "queryAnalysis.summary.type": "crwdns4107:0crwdne4107:0",
  "queryAnalysis.summary.cubes": "crwdns4109:0crwdne4109:0",
  "queryAnalysis.summary.joins": "crwdns4111:0crwdne4111:0",
  "queryAnalysis.summary.ctes": "crwdns4113:0crwdne4113:0",
  "queryAnalysis.summary.strategy": "crwdns4115:0crwdne4115:0",
  "queryAnalysis.primaryCube": "crwdns4117:0crwdne4117:0",
  "queryAnalysis.primaryCube.showCandidates": "crwdns4119:0{count}crwdne4119:0",
  "queryAnalysis.primaryCube.reachable": "crwdns4121:0crwdne4121:0",
  "queryAnalysis.primaryCube.cannotReachAll": "crwdns4123:0crwdne4123:0",
  "queryAnalysis.joinPaths": "crwdns4125:0crwdne4125:0",
  "queryAnalysis.joinPaths.steps": "crwdns4127:0{count}crwdne4127:0",
  "queryAnalysis.joinPaths.stepsPlural": "crwdns4129:0{count}crwdne4129:0",
  "queryAnalysis.joinPaths.noPath": "crwdns4131:0crwdne4131:0",
  "queryAnalysis.joinPaths.selection": "crwdns4133:0crwdne4133:0",
  "queryAnalysis.joinPaths.pathCandidates": "crwdns4135:0{count}crwdne4135:0",
  "queryAnalysis.joinPaths.visitedCubes": "crwdns4137:0{count}crwdne4137:0",
  "queryAnalysis.preAggregations": "crwdns4139:0crwdne4139:0",
  "queryAnalysis.preAggregations.measures": "crwdns4141:0crwdne4141:0",
  "queryAnalysis.preAggregations.joinKeys": "crwdns4143:0crwdne4143:0",
  "queryAnalysis.warnings": "crwdns4145:0crwdne4145:0",
  "queryAnalysis.cubesInvolved": "crwdns4147:0crwdne4147:0",
  "common.actions.copied": "crwdns4149:0crwdne4149:0",
  "common.actions.copyToClipboard": "crwdns4151:0crwdne4151:0",
  "chart.availability.requiresMeasure": "Requires at least 1 measure",
  "chart.availability.requiresTwoMeasures": "Requires at least 2 measures",
  "chart.availability.requiresDimension": "Requires at least 1 dimension",
  "chart.availability.requiresTwoDimensions": "Requires at least 2 dimensions",
  "chart.availability.requiresTimeDimension": "Requires a time dimension",
  "chart.availability.scatter": "Requires 2 measures, or 1 measure plus 1 dimension",
  "chart.availability.bubble": "Requires at least 2 measures and 1 dimension",

  "chart.runtime.noData": "crwdns4153:0crwdne4153:0",
  "chart.runtime.noDataHint.bar": "crwdns4155:0crwdne4155:0",
  "chart.runtime.noDataHint.line": "crwdns4157:0crwdne4157:0",
  "chart.runtime.noDataHint.area": "crwdns4159:0crwdne4159:0",
  "chart.runtime.noDataHint.pie": "crwdns4161:0crwdne4161:0",
  "chart.runtime.noDataHint.scatter": "crwdns4163:0crwdne4163:0",
  "chart.runtime.noDataHint.radar": "crwdns4165:0crwdne4165:0",
  "chart.runtime.noDataHint.radialBar": "crwdns4167:0crwdne4167:0",
  "chart.runtime.noDataHint.treemap": "crwdns4169:0crwdne4169:0",
  "chart.runtime.noDataHint.bubble": "crwdns4171:0crwdne4171:0",
  "chart.runtime.noDataHint.boxPlot": "crwdns4173:0crwdne4173:0",
  "chart.runtime.noDataHint.waterfall": "crwdns4175:0crwdne4175:0",
  "chart.runtime.noDataHint.candlestick": "crwdns4177:0crwdne4177:0",
  "chart.runtime.noDataHint.gauge": "crwdns4179:0crwdne4179:0",
  "chart.runtime.noDataHint.measureProfile": "crwdns4181:0crwdne4181:0",
  "chart.runtime.noDataHint.activityGrid": "crwdns4183:0crwdne4183:0",
  "chart.runtime.noDataHint.heatmap": "crwdns4185:0crwdne4185:0",
  "chart.runtime.noDataHint.table": "crwdns4187:0crwdne4187:0",
  "chart.runtime.noDataHint.kpi": "crwdns4189:0crwdne4189:0",
  "chart.runtime.noDataHint.funnel": "crwdns4191:0crwdne4191:0",
  "chart.runtime.noDataHint.flow": "crwdns4193:0crwdne4193:0",
  "chart.runtime.noDataHint.retention": "crwdns4195:0crwdne4195:0",
  "chart.runtime.noValidData": "crwdns4197:0crwdne4197:0",
  "chart.runtime.noValidDataHint.bar": "crwdns4199:0crwdne4199:0",
  "chart.runtime.noValidDataHint.line": "crwdns4201:0crwdne4201:0",
  "chart.runtime.noValidDataHint.area": "crwdns4203:0crwdne4203:0",
  "chart.runtime.noValidDataHint.scatter": "crwdns4205:0crwdne4205:0",
  "chart.runtime.noValidDataHint.radar": "crwdns4207:0crwdne4207:0",
  "chart.runtime.noValidDataHint.radialBar": "crwdns4209:0crwdne4209:0",
  "chart.runtime.noValidDataHint.treemap": "crwdns4211:0crwdne4211:0",
  "chart.runtime.noValidDataHint.pie": "crwdns4213:0crwdne4213:0",
  "chart.runtime.noValidDataHint.pieFiltered": "crwdns4215:0{count}crwdne4215:0",
  "chart.runtime.noValidDataHint.boxPlot": "crwdns4217:0crwdne4217:0",
  "chart.runtime.noValidDataHint.gauge": "crwdns4219:0crwdne4219:0",
  "chart.runtime.noValidDataHint.kpiText": "crwdns4221:0crwdne4221:0",
  "chart.runtime.configError": "crwdns4223:0crwdne4223:0",
  "chart.runtime.configErrorHint.axisInvalid": "crwdns4225:0crwdne4225:0",
  "chart.runtime.configErrorHint.axisFields": "crwdns4227:0crwdne4227:0",
  "chart.runtime.configErrorHint.pieAxis": "crwdns4229:0crwdne4229:0",
  "chart.runtime.configErrorHint.radarNumeric": "crwdns4231:0crwdne4231:0",
  "chart.runtime.configErrorHint.radialBarNumeric": "crwdns4233:0crwdne4233:0",
  "chart.runtime.configErrorHint.treemapNumeric": "crwdns4235:0crwdne4235:0",
  "chart.runtime.configErrorHint.noMeasure": "crwdns4237:0crwdne4237:0",
  "chart.runtime.configErrorHint.noMeasures": "crwdns4239:0crwdne4239:0",
  "chart.runtime.configErrorHint.bubbleRequired": "crwdns4241:0crwdne4241:0",
  "chart.runtime.configErrorHint.bubbleOptional": "crwdns4243:0crwdne4243:0",
  "chart.runtime.configErrorHint.activityGridRequired": "crwdns4245:0crwdne4245:0",
  "chart.runtime.chartError": "crwdns4247:0{chartType}crwdne4247:0",
  "chart.runtime.unknownError": "crwdns4249:0crwdne4249:0",
  "chart.runtime.checkConfig": "crwdns4251:0crwdne4251:0",
  "chart.runtime.unableToRender": "crwdns4253:0crwdne4253:0",
  "chart.runtime.dataFormatIncorrect": "crwdns4255:0crwdne4255:0",
  "chart.runtime.measuringDimensions": "crwdns4257:0crwdne4257:0",
  "chart.runtime.unableToDisplay": "crwdns4259:0crwdne4259:0",
  "chart.runtime.responsiveContainerError": "crwdns4261:0crwdne4261:0",
  "chart.runtime.noDataToDisplay": "crwdns4263:0crwdne4263:0",
  "chart.runtime.table.invalidStructure": "crwdns4265:0crwdne4265:0",
  "chart.runtime.heatmapNoResults": "crwdns4267:0crwdne4267:0",
  "chart.runtime.heatmapConfigRequired": "crwdns4269:0crwdne4269:0",
  "chart.runtime.heatmapXRequired": "crwdns4271:0crwdne4271:0",
  "chart.runtime.heatmapYRequired": "crwdns4273:0crwdne4273:0",
  "chart.runtime.heatmapValueRequired": "crwdns4275:0crwdne4275:0",
  "chart.runtime.heatmapTruncated": "crwdns4277:0{maxRows}crwdnd4277:0{maxCols}crwdnd4277:0{originalRows}crwdnd4277:0{originalCols}crwdne4277:0",
  "chart.runtime.activityGridGranularityTooHigh": "crwdns4279:0crwdne4279:0",
  "chart.runtime.activityGridGranularityHint": "crwdns4281:0crwdne4281:0",
  "chart.runtime.activityGridGranularityAction": "crwdns4283:0crwdne4283:0",
  "chart.runtime.activityGridConfigRequired": "crwdns4285:0crwdne4285:0",
  "chart.runtime.retention.cohort": "crwdns4287:0crwdne4287:0",
  "chart.runtime.retention.segment": "crwdns4289:0crwdne4289:0",
  "chart.runtime.retention.users": "crwdns4291:0crwdne4291:0",
  "chart.runtime.retention.cohortSize": "crwdns4293:0{count}crwdne4293:0",
  "chart.runtime.retention.retained": "crwdns4295:0{count}crwdne4295:0",
  "chart.runtime.retention.rate": "crwdns4297:0{rate}crwdne4297:0",
  "chart.runtime.retention.retentionPercent": "crwdns4299:0crwdne4299:0",
  "chart.runtime.retention.periodLabel": "crwdns4301:0{cohort}crwdnd4301:0{period}crwdne4301:0",
  "chart.runtime.retention.noData": "crwdns4303:0crwdne4303:0",
  "chart.runtime.retention.total": "crwdns4305:0crwdne4305:0",
  "chart.runtime.retention.retention": "crwdns4307:0crwdne4307:0",
  "chart.runtime.funnel.noData": "crwdns4309:0crwdne4309:0",
  "chart.runtime.funnel.steps": "crwdns4311:0crwdne4311:0",
  "chart.runtime.funnel.overall": "crwdns4313:0crwdne4313:0",
  "chart.runtime.funnel.completed": "crwdns4315:0{completed}crwdnd4315:0{total}crwdne4315:0",
  "chart.runtime.flow.noData": "crwdns4317:0crwdne4317:0",
  "chart.runtime.flow.events": "crwdns4319:0crwdne4319:0",
  "chart.runtime.flow.eventsAfter": "crwdns4321:0crwdne4321:0",
  "chart.runtime.flow.paths": "crwdns4323:0crwdne4323:0",
  "chart.runtime.flow.startingEntities": "crwdns4325:0crwdne4325:0",
  "chart.runtime.flow.entities": "crwdns4327:0crwdne4327:0",
  "chart.runtime.kpiDelta.insufficientData": "crwdns4329:0crwdne4329:0",
  "chart.runtime.kpiDelta.requiresTwoPoints": "crwdns4331:0crwdne4331:0",
  "chart.runtime.kpiDelta.currentPoints": "crwdns4333:0{count}crwdne4333:0",
  "chart.runtime.kpiDelta.noVariance": "crwdns4335:0crwdne4335:0",
  "chart.runtime.kpiNumber.noData": "crwdns4337:0crwdne4337:0",
  "chart.runtime.markdown.noContent": "crwdns4339:0crwdne4339:0",
  "chart.runtime.markdown.addContent": "crwdns4341:0crwdne4341:0",
  "chart.runtime.axisFormat.label": "crwdns4343:0crwdne4343:0",
  "chart.runtime.axisFormat.autoLabel": "crwdns4345:0crwdne4345:0",
  "chart.runtime.axisFormat.unit": "crwdns4347:0crwdne4347:0",
  "chart.runtime.axisFormat.custom": "crwdns4349:0crwdne4349:0",
  "chart.runtime.axisFormat.prefix": "crwdns4351:0crwdne4351:0",
  "chart.runtime.axisFormat.prefixExample": "crwdns4353:0crwdne4353:0",
  "chart.runtime.axisFormat.suffix": "crwdns4355:0crwdne4355:0",
  "chart.runtime.axisFormat.suffixExample": "crwdns4357:0crwdne4357:0",
  "chart.runtime.axisFormat.abbreviation": "crwdns4359:0crwdne4359:0",
  "chart.runtime.axisFormat.yes": "crwdns4361:0crwdne4361:0",
  "chart.runtime.axisFormat.no": "crwdns4363:0crwdne4363:0",
  "chart.runtime.axisFormat.decimals": "crwdns4365:0crwdne4365:0",
  "chart.runtime.axisFormat.preview": "crwdns4367:0crwdne4367:0",
  "chart.runtime.axisFormat.leftYAxis": "crwdns4369:0crwdne4369:0",
  "chart.runtime.axisFormat.rightYAxis": "crwdns4371:0crwdne4371:0",
  "chart.runtime.axisFormat.xAxis": "crwdns4373:0crwdne4373:0",
  "chart.runtime.missingDep.title": "crwdns4375:0crwdne4375:0",
  "chart.runtime.missingDep.description": "crwdns4377:0{chartType}crwdnd4377:0{packageName}crwdne4377:0",
  "chart.runtime.missingDep.restartHint": "crwdns4379:0crwdne4379:0",
  "chart.runtime.unknownChartType": "crwdns4381:0crwdne4381:0",
  "chart.runtime.unknownChartTypeHint": "crwdns4383:0{chartType}crwdne4383:0",
  "chart.runtime.boxPlot.truncated": "crwdns4385:0{max}crwdnd4385:0{total}crwdne4385:0",
  "chart.runtime.candlestick.truncated": "crwdns4387:0{max}crwdnd4387:0{total}crwdne4387:0",
  "chart.runtime.bar.hiddenPoints": "crwdns4389:0{count}crwdne4389:0",
  "chart.runtime.waterfall.increase": "crwdns4391:0crwdne4391:0",
  "chart.runtime.waterfall.decrease": "crwdns4393:0crwdne4393:0",
  "chart.runtime.waterfall.total": "crwdns4395:0crwdne4395:0",
  "chart.runtime.tooltip.noData": "crwdns4397:0crwdne4397:0",
  "chart.runtime.tooltip.targetValue": "crwdns4399:0crwdne4399:0",
  "results.toolbar.refreshing": "crwdns4401:0crwdne4401:0",
  "results.toolbar.refresh": "crwdns4403:0crwdne4403:0",
  "results.toolbar.refreshTitle": "crwdns4405:0crwdne4405:0",
  "results.toolbar.refreshingTitle": "crwdns4407:0crwdne4407:0",
  "results.toolbar.cacheBustTitle": "crwdns4409:0crwdne4409:0",
  "results.toolbar.clear": "crwdns4411:0crwdne4411:0",
  "results.toolbar.clearFunnel": "crwdns4413:0crwdne4413:0",
  "results.toolbar.clearQuery": "crwdns4415:0crwdne4415:0",
  "results.toolbar.aiClose": "crwdns4417:0crwdne4417:0",
  "results.toolbar.aiOpen": "crwdns4419:0crwdne4419:0",
  "results.toolbar.shareTitle": "crwdns4421:0crwdne4421:0",
  "results.toolbar.shareCopied": "crwdns4423:0crwdne4423:0",
  "results.toolbar.schemaHide": "crwdns4425:0crwdne4425:0",
  "results.toolbar.schemaShow": "crwdns4427:0crwdne4427:0",
  "results.toolbar.debugHide": "crwdns4429:0crwdne4429:0",
  "results.toolbar.debugShow": "crwdns4431:0crwdne4431:0",
  "results.toolbar.chartView": "crwdns4433:0crwdne4433:0",
  "results.toolbar.chartDisabled": "crwdns4435:0crwdne4435:0",
  "results.toolbar.tableView": "crwdns4437:0crwdne4437:0",
  "results.toolbar.mergedTableView": "crwdns4439:0crwdne4439:0",
  "results.view.table": "crwdns4441:0crwdne4441:0",
  "results.warning.filterHint": "crwdns4443:0crwdne4443:0",
  "results.debug.query": "crwdns4445:0crwdne4445:0",
  "results.debug.queryAnalysis": "crwdns4447:0crwdne4447:0",
  "results.debug.copyMarkdownTitle": "crwdns4449:0crwdne4449:0",
  "results.debug.copyAsMarkdown": "crwdns4451:0crwdne4451:0",
  "results.debug.analysisError": "crwdns4453:0crwdne4453:0",
  "results.debug.analysisEmpty": "crwdns4455:0crwdne4455:0",
  "results.debug.cubeQuery": "crwdns4457:0crwdne4457:0",
  "results.debug.cubeQueryExecuted": "crwdns4459:0crwdne4459:0",
  "results.debug.funnelFilterHint": "crwdns4461:0crwdne4461:0",
  "results.debug.noQuery": "crwdns4463:0crwdne4463:0",
  "results.debug.serverResponse": "crwdns4465:0crwdne4465:0",
  "results.debug.noResults": "crwdns4467:0crwdne4467:0",
  "results.debug.chartConfig": "crwdns4469:0crwdne4469:0",
  "results.debug.displayConfig": "crwdns4471:0crwdne4471:0",
  "results.debug.generatedSql": "crwdns4473:0crwdne4473:0",
  "results.debug.loadingSql": "crwdns4475:0crwdne4475:0",
  "results.debug.executionError": "crwdns4477:0crwdne4477:0",
  "results.confirm.clearFunnel": "crwdns4479:0crwdne4479:0",
  "results.confirm.clearQuery": "crwdns4481:0crwdne4481:0",
  "results.confirm.clearFunnelMessage": "crwdns4483:0crwdne4483:0",
  "results.confirm.clearQueryMessage": "crwdns4485:0crwdne4485:0",
  "results.table.noData": "crwdns4487:0crwdne4487:0",
  "results.table.noDataHint": "crwdns4489:0crwdne4489:0",
  "results.flow.noData": "crwdns4491:0crwdne4491:0",
  "results.flow.noDataHint": "crwdns4493:0crwdne4493:0",
  "results.flow.nodes": "crwdns4495:0{count}crwdne4495:0",
  "results.flow.transitions": "crwdns4497:0{count}crwdne4497:0",
  "results.flow.layer": "crwdns4499:0crwdne4499:0",
  "results.flow.name": "crwdns4501:0crwdne4501:0",
  "results.flow.count": "crwdns4503:0crwdne4503:0",
  "results.flow.from": "crwdns4505:0crwdne4505:0",
  "results.flow.to": "crwdns4507:0crwdne4507:0",
  "results.debug.funnel.label": "crwdns4509:0crwdne4509:0",
  "results.debug.funnel.steps": "crwdns4511:0{count}crwdne4511:0",
  "results.debug.funnel.serverQuery": "crwdns4513:0crwdne4513:0",
  "results.debug.funnel.noQuery": "crwdns4515:0crwdne4515:0",
  "results.debug.funnel.sqlPlaceholder": "crwdns4517:0crwdne4517:0",
  "results.debug.funnel.stepsTitle": "crwdns4519:0crwdne4519:0",
  "results.debug.flow.label": "crwdns4521:0crwdne4521:0",
  "results.debug.flow.badge": "crwdns4523:0{before}crwdnd4523:0{after}crwdne4523:0",
  "results.debug.flow.serverQuery": "crwdns4525:0crwdne4525:0",
  "results.debug.flow.noQuery": "crwdns4527:0crwdne4527:0",
  "results.debug.flow.sqlPlaceholder": "crwdns4529:0crwdne4529:0",
  "results.debug.flow.configTitle": "crwdns4531:0crwdne4531:0",
  "results.debug.flow.startingStep": "crwdns4533:0crwdne4533:0",
  "results.debug.flow.eventDimension": "crwdns4535:0crwdne4535:0",
  "results.debug.flow.stepsBefore": "crwdns4537:0crwdne4537:0",
  "results.debug.flow.stepsAfter": "crwdns4539:0crwdne4539:0",
  "results.debug.flow.notSet": "crwdns4541:0crwdne4541:0",
  "results.debug.flow.responseTitle": "crwdns4543:0crwdne4543:0",
  "results.debug.retention.label": "crwdns4545:0crwdne4545:0",
  "results.debug.retention.badge": "crwdns4547:0{segments}crwdnd4547:0{users}crwdne4547:0",
  "results.debug.retention.serverQuery": "crwdns4549:0crwdne4549:0",
  "results.debug.retention.configIncomplete": "crwdns4551:0crwdne4551:0",
  "results.debug.retention.configHint": "crwdns4553:0crwdne4553:0",
  "results.debug.retention.sqlPlaceholder": "crwdns4555:0crwdne4555:0",
  "results.debug.retention.configTitle": "crwdns4557:0crwdne4557:0",
  "results.debug.retention.summaryTitle": "crwdns4559:0crwdne4559:0",
  "results.debug.retention.retentionType": "crwdns4561:0crwdne4561:0",
  "results.debug.retention.periods": "crwdns4563:0crwdne4563:0",
  "results.debug.retention.granularity": "crwdns4565:0crwdne4565:0",
  "results.debug.retention.segments": "crwdns4567:0crwdne4567:0",
  "results.debug.retention.avgPeriod1": "crwdns4569:0crwdne4569:0",
  "results.debug.retention.maxPeriod1": "crwdns4571:0crwdne4571:0",
  "results.debug.retention.minPeriod1": "crwdns4573:0crwdne4573:0",
  "results.debug.standard.sqlPlaceholder": "crwdns4575:0crwdne4575:0",
  "flow.tabs.flow": "crwdns4577:0crwdne4577:0",
  "flow.tabs.display": "crwdns4579:0crwdne4579:0",
  "flow.tabs.displayUnavailable": "crwdns4581:0crwdne4581:0",
  "flow.tabs.displayTitle": "crwdns4583:0crwdne4583:0",
  "flow.visualization.title": "crwdns4585:0crwdne4585:0",
  "flow.visualization.description": "crwdns4587:0crwdne4587:0",
  "flow.visualization.sankey": "crwdns4589:0crwdne4589:0",
  "flow.visualization.sankeyHint": "crwdns4591:0crwdne4591:0",
  "flow.visualization.sunburst": "crwdns4593:0crwdne4593:0",
  "flow.visualization.sunburstHint": "crwdns4595:0crwdne4595:0",
  "flow.startingStep.title": "crwdns4597:0crwdne4597:0",
  "flow.startingStep.description": "crwdns4599:0crwdne4599:0",
  "flow.startingStep.filterLabel": "crwdns4601:0crwdne4601:0",
  "flow.depth.title": "crwdns4603:0crwdne4603:0",
  "flow.depth.descriptionSankey": "crwdns4605:0crwdne4605:0",
  "flow.depth.descriptionSunburst": "crwdns4607:0crwdne4607:0",
  "flow.depth.stepsBefore": "crwdns4609:0crwdne4609:0",
  "flow.depth.stepsBeforeNA": "crwdns4611:0crwdne4611:0",
  "flow.depth.stepsAfter": "crwdns4613:0crwdne4613:0",
  "flow.depth.performanceWarning": "crwdns4615:0crwdne4615:0",
  "flow.joinStrategy.title": "crwdns4617:0crwdne4617:0",
  "flow.joinStrategy.description": "crwdns4619:0crwdne4619:0",
  "flow.joinStrategy.auto": "crwdns4621:0crwdne4621:0",
  "flow.joinStrategy.lateral": "crwdns4623:0crwdne4623:0",
  "flow.joinStrategy.window": "crwdns4625:0crwdne4625:0",
  "retention.tabs.retention": "crwdns4627:0crwdne4627:0",
  "retention.tabs.display": "crwdns4629:0crwdne4629:0",
  "retention.tabs.displayUnavailable": "crwdns4631:0crwdne4631:0",
  "retention.tabs.displayTitle": "crwdns4633:0crwdne4633:0",
  "retention.dateRange.title": "crwdns4635:0crwdne4635:0",
  "retention.dateRange.description": "crwdns4637:0crwdne4637:0",
  "retention.dateRange.label": "crwdns4639:0crwdne4639:0",
  "retention.dateRange.selectRange": "crwdns4641:0crwdne4641:0",
  "retention.dateRange.customRange": "crwdns4643:0crwdne4643:0",
  "retention.dateRange.applyCustom": "crwdns4645:0crwdne4645:0",
  "retention.cohortFilter.title": "crwdns4647:0crwdne4647:0",
  "retention.cohortFilter.description": "crwdns4649:0crwdne4649:0",
  "retention.returnFilter.title": "crwdns4651:0crwdne4651:0",
  "retention.returnFilter.description": "crwdns4653:0crwdne4653:0",
  "retention.breakdown.title": "crwdns4655:0crwdne4655:0",
  "retention.breakdown.description": "crwdns4657:0crwdne4657:0",
  "retention.settings.title": "crwdns4659:0crwdne4659:0",
  "retention.settings.description": "crwdns4661:0crwdne4661:0",
  "retention.settings.granularityLabel": "crwdns4663:0crwdne4663:0",
  "retention.settings.periodsLabel": "crwdns4665:0{min}crwdnd4665:0{max}crwdne4665:0",
  "retention.settings.periodsWarning": "crwdns4667:0crwdne4667:0",
  "retention.settings.retentionTypeLabel": "crwdns4669:0crwdne4669:0",
  "debug.explainPlan": "crwdns4671:0crwdne4671:0",
  "debug.explainRunning": "crwdns4673:0crwdne4673:0",
  "debug.explainIncludeTiming": "crwdns4675:0crwdne4675:0",
  "debug.explainRunningAnalyze": "crwdns4677:0crwdne4677:0",
  "debug.explainRunningBasic": "crwdns4679:0crwdne4679:0",
  "debug.explainError": "crwdns4681:0crwdne4681:0",
  "debug.sequentialScans": "crwdns4683:0crwdne4683:0",
  "debug.indexesUsed": "crwdns4685:0{count}crwdne4685:0",
  "debug.indexesUsedPlural": "crwdns4687:0{count}crwdne4687:0",
  "debug.executionTime": "crwdns4689:0{time}crwdne4689:0",
  "debug.planningTime": "crwdns4691:0{time}crwdne4691:0",
  "debug.cost": "crwdns4693:0{cost}crwdne4693:0",
  "debug.indexes": "crwdns4695:0crwdne4695:0",
  "debug.executionPlanTitle": "crwdns4697:0{database}crwdne4697:0",
  "debug.aiAnalyzing": "crwdns4699:0crwdne4699:0",
  "debug.aiAnalysis": "crwdns4701:0crwdne4701:0",
  "debug.aiAnalysisError": "crwdns4703:0crwdne4703:0",
  "explainAI.title": "crwdns4705:0crwdne4705:0",
  "explainAI.assessment.good": "crwdns4707:0crwdne4707:0",
  "explainAI.assessment.warning": "crwdns4709:0crwdne4709:0",
  "explainAI.assessment.critical": "crwdns4711:0crwdne4711:0",
  "explainAI.summary": "crwdns4713:0crwdne4713:0",
  "explainAI.queryAnalysis": "crwdns4715:0crwdne4715:0",
  "explainAI.issuesFound": "crwdns4717:0{count}crwdne4717:0",
  "explainAI.recommendations": "crwdns4719:0{count}crwdne4719:0",
  "explainAI.noRecommendations": "crwdns4721:0crwdne4721:0",
  "explainAI.expectedImpact": "crwdns4723:0crwdne4723:0",
  "explainAI.addToCube": "crwdns4725:0{cubeName}crwdne4725:0",
  "explainAI.modelLabel": "crwdns4727:0crwdne4727:0",
  "explainAI.usingUserKey": "crwdns4729:0crwdne4729:0",
  "explainAI.copied": "crwdns4731:0crwdne4731:0",
  "explainAI.copy": "crwdns4733:0crwdne4733:0",
  "explainAI.type.index": "crwdns4735:0crwdne4735:0",
  "explainAI.type.table": "crwdns4737:0crwdne4737:0",
  "explainAI.type.cube": "crwdns4739:0crwdne4739:0",
  "explainAI.type.general": "crwdns4741:0crwdne4741:0",
  "errorBoundary.modeError": "crwdns4743:0crwdne4743:0",
  "errorBoundary.modeErrorDescription": "crwdns4745:0{mode}crwdne4745:0",
  "errorBoundary.showDetails": "crwdns4747:0crwdne4747:0",
  "errorBoundary.unknownError": "crwdns4749:0crwdne4749:0",
  "errorBoundary.tryAgain": "crwdns4751:0crwdne4751:0",
  "errorBoundary.switchToQuery": "crwdns4753:0crwdne4753:0",
  "funnel.tabs.steps": "crwdns4755:0crwdne4755:0",
  "funnel.tabs.display": "crwdns4757:0crwdne4757:0",
  "funnel.tabs.displayUnavailable": "crwdns4759:0crwdne4759:0",
  "funnel.tabs.displayTitle": "crwdns4761:0crwdne4761:0",
  "funnel.steps.title": "crwdns4763:0crwdne4763:0",
  "funnel.steps.emptyMessage": "crwdns4765:0crwdne4765:0",
  "funnel.steps.addFirst": "crwdns4767:0crwdne4767:0",
  "funnel.steps.addStep": "crwdns4769:0crwdne4769:0",
  "funnel.steps.validationHint": "crwdns4771:0crwdne4771:0",
  "funnel.step.removeTitle": "crwdns4773:0crwdne4773:0",
  "funnel.step.editNameTitle": "crwdns4775:0crwdne4775:0",
  "funnel.step.placeholder": "crwdns4777:0crwdne4777:0",
  "funnel.step.timeWindow": "crwdns4779:0crwdne4779:0",
  "funnel.step.timeWindowHelp": "crwdns4781:0crwdne4781:0",
  "funnel.step.filters": "crwdns4783:0{count}crwdne4783:0",
  "funnel.step.filtersPlural": "crwdns4785:0{count}crwdne4785:0",
  "funnel.step.within": "crwdns4787:0{time}crwdne4787:0",
  "funnel.step.noFilters": "crwdns4789:0crwdne4789:0",
  "funnel.config.configuration": "crwdns4791:0crwdne4791:0",
  "funnel.config.cube": "crwdns4793:0crwdne4793:0",
  "funnel.config.cubeHelp": "crwdns4795:0crwdne4795:0",
  "funnel.config.cubePlaceholder": "crwdns4797:0crwdne4797:0",
  "funnel.config.bindingKey": "crwdns4799:0crwdne4799:0",
  "funnel.config.bindingKeyHelp": "crwdns4801:0crwdne4801:0",
  "funnel.config.bindingKeyPlaceholder": "crwdns4803:0crwdne4803:0",
  "funnel.config.selectCubeFirst": "crwdns4805:0crwdne4805:0",
  "funnel.config.timeDimension": "crwdns4807:0crwdne4807:0",
  "funnel.config.timeDimensionHelp": "crwdns4809:0crwdne4809:0",
  "funnel.config.timeDimensionPlaceholder": "crwdns4811:0crwdne4811:0",
  "funnel.config.noMatchingFields": "crwdns4813:0crwdne4813:0",
  "funnel.bindingKey.searchPlaceholder": "crwdns4815:0crwdne4815:0",
  "funnel.bindingKey.noMatching": "crwdns4817:0crwdne4817:0",
  "funnel.bindingKey.helpText": "crwdns4819:0crwdne4819:0",
  "funnel.bindingKey.clearTitle": "crwdns4821:0crwdne4821:0",
  "flow.config.configuration": "crwdns4823:0crwdne4823:0",
  "flow.config.cube": "crwdns4825:0crwdne4825:0",
  "flow.config.cubeHelp": "crwdns4827:0crwdne4827:0",
  "flow.config.cubePlaceholder": "crwdns4829:0crwdne4829:0",
  "flow.config.bindingKey": "crwdns4831:0crwdne4831:0",
  "flow.config.bindingKeyHelp": "crwdns4833:0crwdne4833:0",
  "flow.config.bindingKeyPlaceholder": "crwdns4835:0crwdne4835:0",
  "flow.config.selectCubeFirst": "crwdns4837:0crwdne4837:0",
  "flow.config.timeDimension": "crwdns4839:0crwdne4839:0",
  "flow.config.timeDimensionHelp": "crwdns4841:0crwdne4841:0",
  "flow.config.timeDimensionPlaceholder": "crwdns4843:0crwdne4843:0",
  "flow.config.eventDimension": "crwdns4845:0crwdne4845:0",
  "flow.config.eventDimensionHelp": "crwdns4847:0crwdne4847:0",
  "flow.config.eventDimensionPlaceholder": "crwdns4849:0crwdne4849:0",
  "flow.config.noMatchingFields": "crwdns4851:0crwdne4851:0",
  "retention.config.configuration": "crwdns4853:0crwdne4853:0",
  "retention.config.cube": "crwdns4855:0crwdne4855:0",
  "retention.config.cubeHelp": "crwdns4857:0crwdne4857:0",
  "retention.config.cubePlaceholder": "crwdns4859:0crwdne4859:0",
  "retention.config.bindingKey": "crwdns4861:0crwdne4861:0",
  "retention.config.bindingKeyHelp": "crwdns4863:0crwdne4863:0",
  "retention.config.bindingKeyPlaceholder": "crwdns4865:0crwdne4865:0",
  "retention.config.selectCubeFirst": "crwdns4867:0crwdne4867:0",
  "retention.config.timestamp": "crwdns4869:0crwdne4869:0",
  "retention.config.timestampHelp": "crwdns4871:0crwdne4871:0",
  "retention.config.timestampPlaceholder": "crwdns4873:0crwdne4873:0",
  "retention.config.noMatchingFields": "crwdns4875:0crwdne4875:0",
  "retention.config.searchPlaceholder": "crwdns4877:0crwdne4877:0",
  "display.showLegend": "crwdns4879:0crwdne4879:0",
  "display.showGrid": "crwdns4881:0crwdne4881:0",
  "display.showTooltip": "crwdns4883:0crwdne4883:0",
  "display.stacked": "crwdns4885:0crwdne4885:0",
  "display.hideHeader": "crwdns4887:0crwdne4887:0",
  "fieldSearch.aria.closeDialog": "crwdns4889:0crwdne4889:0",
  "fieldSearch.aria.filterByCube": "crwdns4891:0crwdne4891:0",
  "fieldSearch.aria.cubeCategories": "crwdns4893:0crwdne4893:0",
  "fieldSearch.aria.availableFields": "crwdns4895:0crwdne4895:0",
  "chart.dropZone.required": "crwdns4897:0crwdne4897:0",
  "common.actions.apply": "crwdns4899:0crwdne4899:0",
  "common.actions.done": "crwdns4901:0crwdne4901:0",
  "common.actions.update": "crwdns4903:0crwdne4903:0",
  "common.actions.retry": "crwdns4905:0crwdne4905:0",
  "common.actions.exit": "crwdns4907:0crwdne4907:0",
  "common.actions.selectAll": "crwdns4909:0crwdne4909:0",
  "common.saving": "crwdns4911:0crwdne4911:0",
  "common.labels.title": "crwdns4913:0crwdne4913:0",
  "dashboardFilter.editFilter": "crwdns4915:0crwdne4915:0",
  "dashboardFilter.filterLabel": "crwdns4917:0crwdne4917:0",
  "dashboardFilter.enterFilterLabel": "crwdns4919:0crwdne4919:0",
  "dashboardFilter.universalTimeFilter": "crwdns4921:0crwdne4921:0",
  "dashboardFilter.universalTimeDescription": "crwdns4923:0crwdne4923:0",
  "dashboardFilter.field": "crwdns4925:0crwdne4925:0",
  "dashboardFilter.showDashboardFields": "crwdns4927:0crwdne4927:0",
  "dashboardFilter.showAllFields": "crwdns4929:0crwdne4929:0",
  "dashboardFilter.dashboard": "crwdns4931:0crwdne4931:0",
  "dashboardFilter.all": "crwdns4933:0crwdne4933:0",
  "dashboardFilter.clickToSelectField": "crwdns4935:0crwdne4935:0",
  "dashboardFilter.operator": "crwdns4937:0crwdne4937:0",
  "dashboardFilter.defaultValue": "crwdns4939:0crwdne4939:0",
  "dashboardFilter.deleteFilter": "crwdns4941:0crwdne4941:0",
  "dashboardFilter.noValueRequired": "crwdns4943:0crwdne4943:0",
  "dashboardFilter.to": "crwdns4945:0crwdne4945:0",
  "dashboardFilter.selectValue": "crwdns4947:0crwdne4947:0",
  "dashboardFilter.search": "crwdns4949:0crwdne4949:0",
  "dashboardFilter.errorPrefix": "crwdns4951:0crwdne4951:0",
  "dashboardFilter.noValuesFound": "crwdns4953:0crwdne4953:0",
  "dashboardFilter.enterValue": "crwdns4955:0crwdne4955:0",
  "dashboardFilter.enterNumber": "crwdns4957:0crwdne4957:0",
  "dashboardFilter.min": "crwdns4959:0crwdne4959:0",
  "dashboardFilter.max": "crwdns4961:0crwdne4961:0",
  "dashboardFilter.filterLabelRequired": "crwdns4963:0crwdne4963:0",
  "dashboardFilter.selectFieldRequired": "crwdns4965:0crwdne4965:0",
  "dashboardFilter.notSet": "crwdns4967:0crwdne4967:0",
  "dashboardFilter.clickToConfigure": "crwdns4969:0crwdne4969:0",
  "dashboardFilter.customDate.startDate": "crwdns4971:0crwdne4971:0",
  "dashboardFilter.customDate.endDate": "crwdns4973:0crwdne4973:0",
  "dashboardFilter.customDate.sinceDate": "crwdns4975:0crwdne4975:0",
  "dashboardFilter.customDate.fromSelectedToToday": "crwdns4977:0crwdne4977:0",
  "dashboardFilter.customDate.number": "crwdns4979:0crwdne4979:0",
  "dashboardFilter.customDate.unit": "crwdns4981:0crwdne4981:0",
  "dashboardFilter.customDate.lastNPreview": "crwdns4983:0{number}crwdnd4983:0{unit}crwdne4983:0",
  "dashboardFilter.editMode.filters": "crwdns4985:0crwdne4985:0",
  "dashboardFilter.editMode.noFilters": "crwdns4987:0crwdne4987:0",
  "dashboardFilter.editMode.dateRange": "crwdns4989:0crwdne4989:0",
  "dashboardFilter.editMode.filter": "crwdns4991:0crwdne4991:0",
  "dashboardFilter.editMode.editFilter": "crwdns4993:0crwdne4993:0",
  "dashboardFilter.editMode.removeFilter": "crwdns4995:0crwdne4995:0",
  "dashboardFilter.filterValue.editValue": "crwdns4997:0crwdne4997:0",
  "dashboardFilter.readOnly.filters": "crwdns4999:0crwdne4999:0",
  "filter.shared.fieldsInQuery": "crwdns5001:0{count}crwdne5001:0",
  "filter.shared.allAvailableFields": "crwdns5003:0{count}crwdne5003:0",
  "filter.shared.noFieldsMatch": "crwdns5005:0{searchTerm}crwdne5005:0",
  "filter.shared.searchFields": "crwdns5007:0crwdne5007:0",
  "filter.shared.selectField": "crwdns5009:0crwdne5009:0",
  "filter.shared.schemaNotLoaded": "crwdns5011:0crwdne5011:0",
  "filter.shared.group.addFilter": "crwdns5013:0crwdne5013:0",
  "filter.shared.group.addAndGroup": "crwdns5015:0crwdne5015:0",
  "filter.shared.group.addOrGroup": "crwdns5017:0crwdne5017:0",
  "filter.shared.group.addCondition": "crwdns5019:0crwdne5019:0",
  "filter.shared.group.noConditions": "crwdns5021:0crwdne5021:0",
  "filter.shared.group.addFilterLink": "crwdns5023:0crwdne5023:0",
  "filter.shared.builder.filters": "crwdns5025:0{count}crwdne5025:0",
  "filter.shared.builder.clearAll": "crwdns5027:0crwdne5027:0",
  "filter.shared.builder.addFilter": "crwdns5029:0crwdne5029:0",
  "filter.shared.dateRange.title": "crwdns5031:0{count}crwdne5031:0",
  "filter.shared.dateRange.clearAll": "crwdns5033:0crwdne5033:0",
  "filter.shared.dateRange.addDateRange": "crwdns5035:0crwdne5035:0",
  "filter.shared.dateRange.allHaveDateRanges": "crwdns5037:0crwdne5037:0",
  "filter.shared.valueSelector.noValueRequired": "crwdns5039:0crwdne5039:0",
  "filter.shared.valueSelector.to": "crwdns5041:0crwdne5041:0",
  "filter.shared.valueSelector.min": "crwdns5043:0crwdne5043:0",
  "filter.shared.valueSelector.max": "crwdns5045:0crwdne5045:0",
  "filter.shared.valueSelector.enterNumber": "crwdns5047:0crwdne5047:0",
  "filter.shared.valueSelector.loadingValues": "crwdns5049:0crwdne5049:0",
  "filter.shared.valueSelector.selectValue": "crwdns5051:0crwdne5051:0",
  "filter.shared.valueSelector.searchValues": "crwdns5053:0crwdne5053:0",
  "filter.shared.valueSelector.searching": "crwdns5055:0crwdne5055:0",
  "filter.shared.valueSelector.errorLoading": "crwdns5057:0{error}crwdne5057:0",
  "filter.shared.valueSelector.noMatchingValues": "crwdns5059:0crwdne5059:0",
  "filter.shared.valueSelector.noValuesAvailable": "crwdns5061:0crwdne5061:0",
  "filter.shared.valueSelector.enterValue": "crwdns5063:0{type}crwdne5063:0",
  "dashboard.noPortlets": "crwdns5065:0crwdne5065:0",
  "dashboard.noPortletsDescription": "crwdns5067:0crwdne5067:0",
  "dashboard.addText": "crwdns5069:0crwdne5069:0",
  "dashboard.addPortlet": "crwdns5071:0crwdne5071:0",
  "dashboard.finishEditing": "crwdns5073:0crwdne5073:0",
  "dashboard.edit": "crwdns5075:0crwdne5075:0",
  "dashboard.grid": "crwdns5077:0crwdne5077:0",
  "dashboard.rows": "crwdns5079:0crwdne5079:0",
  "dashboard.desktopRequired": "crwdns5081:0crwdne5081:0",
  "dashboard.editModeHint": "crwdns5083:0crwdne5083:0",
  "dashboard.filterSelectionMode": "crwdns5085:0{filterLabel}crwdne5085:0",
  "dashboard.filterSelectionEscHint": "crwdns5087:0crwdne5087:0",
  "dashboard.editPortlet": "crwdns5089:0crwdne5089:0",
  "dashboard.addNewPortlet": "crwdns5091:0crwdne5091:0",
  "dashboard.updatePortlet": "crwdns5093:0crwdne5093:0",
  "dashboard.deletePortlet": "crwdns5095:0crwdne5095:0",
  "dashboard.deletePortletConfirm": "crwdns5097:0crwdne5097:0",
  "dashboard.deletePortletSuffix": "crwdns5099:0crwdne5099:0",
  "dashboard.thisPortlet": "crwdns5101:0crwdne5101:0",
  "dashboard.editModal.dashboardName": "crwdns5103:0crwdne5103:0",
  "dashboard.editModal.enterDashboardName": "crwdns5105:0crwdne5105:0",
  "dashboard.editModal.descriptionOptional": "crwdns5107:0crwdne5107:0",
  "dashboard.editModal.enterDescription": "crwdns5109:0crwdne5109:0",
  "portlet.configRequired": "crwdns5111:0crwdne5111:0",
  "portlet.configRequiredHint": "crwdns5113:0crwdne5113:0",
  "portlet.queryError": "crwdns5115:0crwdne5115:0",
  "portlet.queryWithFilters": "crwdns5117:0crwdne5117:0",
  "portlet.chartConfig": "crwdns5119:0crwdne5119:0",
  "portlet.noDataAvailable": "crwdns5121:0crwdne5121:0",
  "portlet.noDataDrilled": "crwdns5123:0crwdne5123:0",
  "portlet.invalidQuery": "crwdns5125:0crwdne5125:0",
  "portlet.unsupportedChartType": "crwdns5127:0crwdne5127:0",
  "portlet.unableToRender": "crwdns5129:0crwdne5129:0",
  "portlet.enterTitle": "crwdns5131:0crwdne5131:0",
  "portlet.enterPortletTitle": "crwdns5133:0crwdne5133:0",
  "portlet.configureQuery": "crwdns5135:0crwdne5135:0",
  "portlet.configureFlow": "crwdns5137:0crwdne5137:0",
  "portlet.configureRetention": "crwdns5139:0crwdne5139:0",
  "portlet.configureFunnel": "crwdns5141:0crwdne5141:0",
  "portlet.addMetricOrBreakdown": "crwdns5143:0crwdne5143:0",
  "portlet.filterConfig.title": "crwdns5145:0crwdne5145:0",
  "portlet.filterConfig.subtitle": "crwdns5147:0{portletTitle}crwdne5147:0",
  "portlet.filterConfig.noFilters": "crwdns5149:0crwdne5149:0",
  "portlet.filterConfig.noFiltersHint": "crwdns5151:0crwdne5151:0",
  "portlet.filterConfig.availableFilters": "crwdns5153:0crwdne5153:0",
  "portlet.filterConfig.selectedCount": "crwdns5155:0{selected}crwdnd5155:0{total}crwdne5155:0",
  "portlet.filterConfig.applied": "crwdns5157:0crwdne5157:0",
  "portlet.filterConfig.noValue": "crwdns5159:0crwdne5159:0",
  "portlet.filterConfig.complexFilter": "crwdns5161:0crwdne5161:0",
  "portlet.filterConfig.groupFilter": "crwdns5163:0{type}crwdnd5163:0{count}crwdne5163:0",
  "portlet.filterConfig.groupFilterPlural": "crwdns5165:0{type}crwdnd5165:0{count}crwdne5165:0",
  "portlet.filterConfig.applyFilters": "crwdns5167:0crwdne5167:0",
  "textPortlet.editText": "crwdns5169:0crwdne5169:0",
  "textPortlet.addText": "crwdns5171:0crwdne5171:0",
  "textPortlet.markdownContent": "crwdns5173:0crwdne5173:0",
  "textPortlet.markdownHint": "crwdns5175:0urlcrwdne5175:0",
  "textPortlet.preview": "crwdns5177:0crwdne5177:0",
  "debug.title": "crwdns5179:0crwdne5179:0",
  "debug.chartType": "crwdns5181:0crwdne5181:0",
  "debug.fieldAnalysis": "crwdns5183:0crwdne5183:0",
  "debug.chartConfig": "crwdns5185:0crwdne5185:0",
  "debug.displayConfig": "crwdns5187:0crwdne5187:0",
  "debug.queryObject": "crwdns5189:0crwdne5189:0",
  "debug.dataSample": "crwdns5191:0crwdne5191:0",
  "debug.cacheStatus": "crwdns5193:0crwdne5193:0",
  "debug.cacheHit": "crwdns5195:0crwdne5195:0",
  "debug.cachedAt": "crwdns5197:0crwdne5197:0",
  "debug.ttl": "crwdns5199:0crwdne5199:0",
  "debug.ttlRemaining": "crwdns5201:0crwdne5201:0",
  "debug.freshQuery": "crwdns5203:0crwdne5203:0",
  "debug.notFromCache": "crwdns5205:0crwdne5205:0",
  "debug.escToClose": "crwdns5207:0crwdne5207:0",
  "debug.escKey": "crwdns5209:0crwdne5209:0",
  "debug.toClose": "crwdns5211:0crwdne5211:0",
  "debug.tooltip": "crwdns5213:0crwdne5213:0",
  "error.unableToRender": "crwdns5215:0crwdne5215:0",
  "error.unableToRenderNamed": "crwdns5217:0{title}crwdne5217:0",
  "error.renderDescription": "crwdns5219:0crwdne5219:0",
  "error.errorLabel": "crwdns5221:0crwdne5221:0",
  "error.typeLabel": "crwdns5223:0crwdne5223:0",
  "error.portletConfig": "crwdns5225:0crwdne5225:0",
  "error.cubeQuery": "crwdns5227:0crwdne5227:0",
  "error.componentStack": "crwdns5229:0crwdne5229:0",
  "error.tryAgain": "crwdns5231:0crwdne5231:0",
  "drill.back": "crwdns5233:0crwdne5233:0",
  "drill.goBackOneLevel": "crwdns5235:0crwdne5235:0",
  "drill.returnToTop": "crwdns5237:0crwdne5237:0",
  "drill.navigateTo": "crwdns5239:0{label}crwdne5239:0",
  "drill.empty": "crwdns5241:0crwdne5241:0",
  "analyticsPage.title": "crwdns5243:0crwdne5243:0",
  "dataHistogram.average": "crwdns5507:0{count}crwdne5507:0",
  "dataHistogram.valuesInRange": "crwdns5245:0{count}crwdne5245:0"
}
